import { useState, useEffect, useRef, useContext,useCallback,useMemo } from "react";
import axios from "axios";
import Select, { createFilter } from "react-select";
import CreatableSelect from "react-select/creatable";
import BigShowCompleteCard from "../../Card/BigShowCompleteCard";
//import "../CreateCardForm/CreateCardForm.css";
import { toast } from 'react-toastify';
import ConditionComponent from "../ConditionComponent/ConditionComponent";
import MySvgButtonPlus from "../../UsefulComponent/MySvgButtonPlus";
import { UserContext } from "../../login/LoginForm";
import { AuthContext } from "../../login/AuthContext";
import { Link, Navigate, useNavigate, useLocation, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "../../../assets/css/DoubleSlider.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import debounce from "lodash/debounce";
import SeoHelmet from '../../../Seo/SeoHelmet';
import loupeIcon from '../../../assets/svgs/loupeIcon.svg'
import SelectorIcon from '../../../assets/svgs/SelectorIcon.svg'
import {
  faHockeyPuck,
  faBasketball,
  faHippo,
  faAlignJustify,
} from "@fortawesome/free-solid-svg-icons";
import { teams } from "../../CreateCardForm/teamslist";
import "font-awesome/css/font-awesome.min.css";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import ForSalePriceAndTemplate from "../../CreateCardForm/ForSalePriceAndTemplate";
import ForTradeTradingTemplate from "../../CreateCardForm/ForTradeTradingTemplate";
import { faLockOpen } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../UsefulComponent/Loader";
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import ImageSelector from "../../../utils/icon/ImageSelector";
import DragDropSelector from "../../../utils/icon/DragDropSelector ";
import { gridColumnsTotalWidthSelector } from "@mui/x-data-grid";
import  {searchSelectStyles,
  formSelectStyles,
  compactSelectStyles,
  errorSelectStyles} from "../../../styles/components/selectStyles.js";

function CardEditV2() {
  
  const { t: translate, i18n } = useTranslation(); 
  const currentLang = i18n.language; 
  const t = (key) => translations.CreateCardForm[key][currentLang];
   const { userId,liveCsrfToken,isAuthenticated,loading } = useContext(AuthContext);
 const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const usercardId=id;
  const userNavigatingRef = useRef(false);
  const markUserNav = () => { userNavigatingRef.current = true; };
  const [buttonToggle,setButtonToggle] = useState(false)
  const [setSearchTerm,setSetSearchTerm]= useState('')
const [qsFocused, setQsFocused] = useState(false);
  
  const [formData, setFormData] = useState(null);

  const [lockedFields, setLockedFields] = useState({});
  const [isFieldsLocked, setIsFieldsLocked] = useState(false);
  const [viewPreview, setViewPreview] = useState(false);
  const [errors, setErrors] = useState({});
  const [collections, setCollections] = useState([
    { ListId: 0, Title: "NotAssigned", collectionCount: 0 },
  ]);
const fileFrontRef = useRef(null);
const fileBackRef  = useRef(null);
  const [selectKey, setSelectKey] = useState(Date.now());

  const toIntBool = (val) => ['true', true, 1, '1'].includes(val) ? 1 : 0;
  const [newPlayer, setNewPlayer] = useState({
    Type: "",
    PlayerName: "",
  });
  const [rookieYearForThisPlayer, setRookieYearForThisPlayer] = useState(0);
  const [playerOptions, setPlayerOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [playerNameTempo, setPlayerNameTempo] = useState("");
  const [variation, setVariation] = useState([]);
  const [cardVariation, setCardVariation] = useState([]);
  const [filteredVariation, setFilteredVariation] = useState("");
  const [liveSelectedVariation, setLiveSelectedVariation] = useState([]);
  const [liveSelectedCardName, setLiveSelectedCardName] = useState([]);
  // State variables for dropdown options
  const [options, setOptions] = useState([]);
  const [setsSelected, setSetsSelected] = useState([]);
  const [previewImageBack, setPreviewImageBack] = useState(location?.state?.card.ImageUserBack ||location?.state?.card.ImageBack);
  const [previewImage, setPreviewImage] = useState(location?.state?.card.ImageFront||location?.state?.card.Image);
  const [setsCurrentlySelected, setSetsCurrentlySelected] = useState(() => {
    const card = location?.state?.card || {};
    return {
      value: card.setId || 0,
      label: card.SetName || '',
      Set: card.TypeSet || '',
      InsertFamilyId:card.InsertFamilyId||'',
    };
  });
  const [selectedType, setSelectedType] = useState(location?.state?.card.CatalogType|| "Hockey");

  
  const FindTheTeamNameById = (teamId) => {
  
    const team = teams[teamId];
   
    return team ? team.name : "Unknown Team";
  };
  const [uniformCurrentlySelected, setUniformCurrentlySelected] = useState({
    value: location?.state?.card?.TeamsId || 0,
    label: location?.state?.card?.TeamsId ? FindTheTeamNameById(location.state.card.TeamsId) : '',
  });
  

const isPokemon = selectedType === "Pokemon";
const [pokemonSet, setPokemonSet] = useState(() => {
  const card = location?.state?.card;
  if (card?.Type === "Pokemon" && card.SetId) {
    return {
      value: card.SetId,
      label: card.SetName,
    };
  }
  return null; // nothing selected by default
});
const [pokemonCard, setPokemonCard] = useState(() => {
  const card = location?.state?.card;
  if (card?.Type === "Pokemon" && (card.PokemonCardId || card.CardId)) {
    return {
      value: card.PokemonCardId || card.CardId,
      label: `${card.CardName || card.Name || ""}${
        card.NumberBehind ? ` #${card.NumberBehind}` : ""
      }`,
      numberBehind: card.NumberBehind ?? null,
      rarityId: card.RarityId ?? null,
      rarityName: card.RarityName ?? null,
    };
  }
  return null;
});

const [pokemonRarity, setPokemonRarity] = useState(() => {
  const card = location?.state?.card;
  if (card?.Type === "Pokemon" && card.RarityId) {
    return {
      value: card.RarityId,
      label: card.RarityName || "",
    };
  }
  return null;
});

const [holoOverride, setHoloOverride] = useState(
  location?.state?.card?.HoloOverride || ""
);
const [pokemonSetInput, setPokemonSetInput] = useState(location?.state?.card.SetName);
const [pokemonSetOptions, setPokemonSetOptions] = useState([]);
const [pokemonCardInput, setPokemonCardInput] = useState(location?.state?.card.CardName);
const [pokemonCardOptions, setPokemonCardOptions] = useState([]);
  const [uniformListForThisPlayer, setUniformListForThisPlayer] = useState([]);
  const [filteredSets, setFilteredSets] = useState([]);
  const [thisIsANewPlayer, setThisIsANewPlayer] = useState(false);
  const [newPlayerName, setNewPlayerName] = useState(() => {
    const card = location?.state?.card || {};
    return {
      value: card.PlayerId || 0,
      label: card.Name || '',
      rookieYear: card.RookieYear || 0,
    };
  });
  

  const [thisIsANewVariation, setThisIsANewVariation] = useState(false);
  const [thisIsANewVariationName, setThisIsANewVariationName] = useState(false);
  const [newVariationName, setNewVariationName] = useState(() => {
    const card = location?.state?.card || {};
    return {
      value: card.IdCardVariation || 0,
      label: card.cardName || '',
      name: card.fromSet || '',
      InsertFamilyId:card.InsertFamilyId||'',
    };
  });
  
  const [newVariation, setNewVariation] = useState(() => {
    const card = location?.state?.card || {};
    return {
      value: card.IDVariation || 0,
      label: card.variationName || '',
      name: card.IdCardVariation || 0,
    };
  });
  
  const [newVariationNameId, setNewVariationNameId] = useState(
    location?.state?.card?.IdCardVariation || 0
  );
  
  const [showGrading, setShowGrading] = useState(false);
  const [testisLoading, setTestIsLoading] = useState(false);
  const [testoptions, setTestOptions] = useState([]);
  const [variationLocked, setVariationLocked] = useState(true);

  const [IsSuggestionOpen, setIsSuggestionOpen] = useState(false);
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [currentSuggestions, setCurrentSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  /*################### double slider ######################*/
  const [range, setRange] = useState([1, 10]);


   const [shouldAutoSelectVariation, setShouldAutoSelectVariation] = useState(false);
  const [allowCreateNewCollection, setAllowCreateNewCollection] =
    useState(false);
  const [selectedCollectionLive, setSelectedCollectionLive] = useState({
    value: 0,
    Title: "NotAssigned",
    collectionCount: 0,
    label:"NotAssigned"
  });

  const [createNewCollectionTitle, setCreateNewCollectionTitle] = useState("");
  const [
    confirmationVisibleCreateNewCollection,
    setConfirmationVisibleCreateNewCollection,
  ] = useState(false);

  const selectRefs = {
    player: useRef(null),
    team: useRef(null),
    set: useRef(null),
    variationName:useRef(null),
    variation: useRef(null),
  };

const focusNextField = (nextField) => {
  if (!userNavigatingRef.current) return;     // ← don’t auto-focus during bootstrap
  setTimeout(() => {
    if (selectRefs[nextField]?.current) {
      selectRefs[nextField].current.focus();
      selectRefs[nextField].current.onMenuOpen?.();
    }
  }, 80);
};
  const [openSelect,setOpenSelect]=useState(null); 
  // Function to find the team name by ID

  const removeImage = (key) => {
  setFormData(prev => ({ ...prev, [key]: "" }));
  if (key === "Image") setPreviewImage("");      // if you keep a separate preview state
  if (key === "ImageBack") setPreviewImageBack("");
};



  const [isFetching, setIsFetching] = useState(false);
  const normalizeInput = (input) => {
    return input
      .trim()
      .toLowerCase()
      .normalize("NFD") // Breaks accented characters into base + accent
      .replace(/[\u0300-\u036f]/g, ""); // Removes accents
  };
  let fetchTimeout;
  let disableConditionSelect
  console.log("location.stateasdasd123", location.state);
  
const mapPokemonCardDataToFormDataFromSearch = (card) => {
  console.log("pokemon cardData Cardsearch", card);

  setPreviewImage(card.ImageFront || card.Image || "");
  setPreviewImageBack("");

  setPokemonSet({
    value: card.SetId,
    label: card.SetName,
  });

  setPokemonCard({
    value: card.CardId,
    label: `${card.CardName || card.Name || ""}${
      card.NumberInSet ? ` #${card.NumberInSet}` : card.NumberBehind ? ` #${card.NumberBehind}` : ""
    }${card.Rarity ? ` · ${card.Rarity}` : ""}`,
    rarity: card.Rarity || null,
    rarityId: card.RarityId || null,
    image: card.ImageFront || card.Image || null,
    setId: card.SetId,
    number: card.NumberInSet || card.NumberBehind || null,
  });

  setPokemonRarity(
    card.RarityId
      ? { value: card.RarityId, label: card.Rarity || card.RarityName || "" }
      : null
  );

  setHoloOverride(card.HoloOverride || "");
  handleInputChange2(card.SearchTitle, false);

  return {
    userCardId: formData?.userCardId || location?.state?.card?.id || null,
    cardId: card.CardId,
    Type: "Pokemon",

    PlayerId: 0,
    Name: card.CardName || card.Name || "",
    RookieYear: 0,
    cardName: card.CardName || card.Name || "",
    YearMade: 0,

    IsRookie: false,
    IsPatch: false,
    IsAuto: false,
    IsJersey: false,

    Variation: "",
    Numbered: "",
    Uniform: 0,

    Sets: card.SetId || "",
    SetName: card.SetName || "",
    InsertFamilyId: "",

    Image: card.ImageFront || card.Image || "",
    ImageBack: "",
    NumberBehind: card.NumberInSet || card.NumberBehind || "",

    SpecialAttribute: "",
    Graded: false,
    GradeCompany: "",
    Grade: 0.0,

    isPC: 0,
    isForSale: 0,
    isForTrade: 0,
    isOnEbay: 0,

    ConditionCard: card.ConditionCard || "NM",
    EstimateValue: card.PriceMarket || 0,
    EstimateAVG: card.PriceMid || 0,
    PaidPrice: 0,
    Location: "",
    SalePrice: 0,
    BestOffer: 0,
    ShippingTemplate: 0,
    Shipping: 0,
    TradingTemplate: 0,
    TradeValue: 0,
    SeeMore: false,
  };
};


  const mapCardDataToFormDataFromSearch = (card) => {
    console.log('cardData Cardsearch',card)
   setPreviewImageBack(card.ImageBack);
    setPreviewImage(card.Image);
    setRookieYearForThisPlayer(card.RookieYear);
   
     setSetsCurrentlySelected({
      value: card.setId,
      label: card.SetName,
      Set: card.TypeSet,
      InsertFamilyId: card.InsertFamilyId
    });
    setUniformCurrentlySelected({
      value: card.TeamsId,
      label: FindTheTeamNameById(card.TeamsId),
    });
    setNewPlayerName({
      value: card.PlayerId,
      label: card.Name,
      rookieYear: card.RookieYear,
    });

    setNewVariationName({
      value: card.IdCardVariation,
      label: card.cardName,
      name: card.fromSet,
      InsertFamilyId: card.InsertFamilyId
    });

    setNewVariation({
      value: card.IDVariation,
      label: card.variationName,
      name: card.IdCardVariation,
    });
    setNewVariationNameId(card.IdCardVariation);

    handleInputChange2(card.SearchTitle, false);

    return {
      cardId: card.CardId,
      PlayerId: card.PlayerId,
      Name: card.Name,
      RookieYear: card.RookieYear,
      Type: card.Type,
      //CardName: card.CardName || "",
      cardName: card.cardName || "",
      YearMade: card.YearMade || 0,
      IsRookie: card.IsRookie === "Rookie(RC)" ? 1 : 0,
      IsPatch: card.IsPatch === "Patch" ? 1 : 0,
      IsAuto: card.IsAuto === "Auto" ? 1 : 0,
      IsJersey: card.IsJersey === "Jersey" ? 1 : 0,
    
      Variation: card.IDVariation || "",
      Numbered: card.numbered || "",
      Uniform: FindTheTeamNameById(card.TeamsId) || "",
      Sets: card.setId || "",
      SetName: card.SetName || "",
      InsertFamilyId:card.InsertFamilyId|| "",
      Image: card.Image || "",
      ImageBack: card.ImageBack || "",
      NumberBehind: card.NumberBehind || "",
      playerNotFound: false,
      NotFoundPlayerInput: "",
      SpecialAttribute: card.SpecialAttribute|| "",
      isPC: 0,
      isForSale: 0,
      isForTrade: 0,
      isOnEbay: 0,
      ConditionCard: card.ConditionCard || "",
      EstimateValue: card.EstimateValue || 0,
      EstimateAVG: card.EstimateAVG || 0,
      PaidPrice: card.PaidPrice || 0,
      Location: card.Location || "",
      SalePrice: card.Price || 0,
      BestOffer: card.BestOffer || 0,
      ShippingTemplate: card.ShippingTemplate || 0,
      Shipping: card.Shipping || 0,
      TradingTemplate: card.TradingTemplate || 0,
      TradeValue: card.TradeValue || 0,
      SeeMore:false,
    };
  };


  useEffect(() => {
    console.log("selectedCollectionLive123", selectedCollectionLive);
  }, [selectedCollectionLive]);
// Function to fetch card data
async function fetchCardData(usercardId) {
  try {
    console.log('usercardId', usercardId);

    // If your frontend is served from the same domain as the API in prod,
    // prefer a relative URL like `/getUserCardsInfo/${usercardId}`
    const url = new URL(
  `${process.env.REACT_APP_API_BASE}/getInfoUserCards/${usercardId}`
);
url.searchParams.set('userId', userId); // TEMP: not secure
    const res = await fetch(
      url.toString(),
      {
        method: 'GET',
        credentials: 'include',       // send cookies/session
        headers: {
          'Accept': 'application/json'
          // DO NOT add Content-Type for GET without body
        }
      }
    );

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(`HTTP ${res.status} ${res.statusText} – ${text}`);
    }

    const data = await res.json();

    if (!Array.isArray(data) || data.length === 0) {
      console.error('No card data found');
      return;
    }

    const cardData = data[0];
    console.log('here is the cardData', cardData);
      console.log('cardData.ImageFront || cardData.Image',cardData.ImageFront,Image )

      setPreviewImageBack(cardData.ImageUserBack || cardData.ImageBack || "")
      setPreviewImage(cardData.ImageFront || cardData.Image || "")
      setSelectedType(cardData.Type)
      setFormData({
        userCardId: cardData.id, // Replace with the correct field from your database
        cardId: cardData.CardId,
        PlayerId: cardData.PlayerId,
        Type: cardData.Type||cardData.CatalogType||"Hockey",
        //CardName: cardData.CardName,
        cardName:cardData.cardName,
        YearMade: cardData.YearMade,
        IsRookie: cardData.IsRookie === "Rookie(RC)" ? 1 : 0,
        IsPatch: cardData.IsPatch === "Patch" ? 1 : 0,
        IsAuto: cardData.IsAuto === "Auto" ? 1 : 0,
        IsJersey: cardData.IsJersey === "Jersey" ? 1 : 0,
        
        Variation: cardData.IDVariation || "",
        Numbered: cardData.numbered || "",
        Uniform: cardData.TeamsId || "",
        Sets: cardData.setId || "",
        InsertFamilyId:cardData.InsertFamilyId|| "",
        SpecialAttribute: cardData.SpecialAttribute || "",
        
        Image: cardData.ImageFront || cardData.Image || "",
        ImageBack: cardData.ImageUserBack || cardData.ImageBack || "",
        NumberBehind: cardData.NumberBehind || "",
        Graded: cardData.Graded === "Graded" ? true : false,
        GradeCompany: cardData.Graded === "Graded" ? cardData.GradeCompany || "" : "",
        Grade: cardData.Graded === "Graded" ? cardData.Grade || 0 : 0,
        isPC: cardData.isPC === "isPC" ? true : false,
        isForSale: cardData.isForSale === "isForSale" ? true : false,
        isForTrade: cardData.isForTrade === "isForTrade" ? true : false,
        isOnEbay: cardData.isOnEbay === "isOnEbay" ? true : false,
        ConditionCard: cardData.ConditionCard || "",
        EstimateValue: cardData.EstimateValue || 0,
        PaidPrice: cardData.PaidPrice || 0,
        Location: cardData.Location || "",
        SalePrice: cardData.Price || 0,
        BestOffer: cardData.BestOffer === 1,
        ShippingTemplate: cardData.ShippingTemplate || 0,
        Shipping: cardData.Shipping || 0,
        TradingTemplate: cardData.TradingTemplate || 0,
        TradeValue: cardData.tradeValue || 0,
        SeeMore:false,
      });
      disableConditionSelect = cardData.Graded === 'Graded' || cardData.Graded === true;
      
      setNewPlayerName({
        value: cardData.PlayerId || '',
        label: cardData.Name || 'Unknown Player',
        rookieYear: cardData.RookieYear || 0,
      });
  
      setUniformCurrentlySelected({
        value: cardData.TeamsId || '',
        label: FindTheTeamNameById(cardData.TeamsId) || 'Unknown Team',
      });
  
      setSetsCurrentlySelected({
        value: cardData.setId || '',
        label: cardData.SetName || 'Unknown Set',
        Set: cardData.TypeSet || '',
        InsertFamilyId:cardData.InsertFamilyId|| "",
      });
  
      setNewVariationName({
        value: cardData.IdCardVariation || '',
        label: cardData.cardName || 'Unknown Variation',
        name: cardData.fromSet || '',
        InsertFamilyId:cardData.InsertFamilyId|| "",
      });
  
      setNewVariation({
        value: cardData.IDVariation || '',
        label: cardData.variationName || 'Unknown Variation',
        name: cardData.IdCardVariation || '',
      });
  
      setNewVariationNameId(cardData.IdCardVariation || '');
    

// 🧩 Si la carte est Pokémon, pré-remplir les selects Pokémon
if (cardData.Type === "Pokemon") {
  setSelectedType("Pokemon");

  if (cardData.SetId || cardData.setId) {
    setPokemonSet({
      value: cardData.SetId || cardData.setId,
      label: cardData.SetName || "",
    });
  }

  if (cardData.CardId) {
    setPokemonCard({
      value: cardData.CardId,
      label: `${cardData.CardName || cardData.Name || ""}${
        cardData.NumberBehind ? ` #${cardData.NumberBehind}` : ""
      }`,
      numberBehind: cardData.NumberBehind ?? null,
      rarityId: cardData.RarityId ?? null,
      rarityName: cardData.RarityName ?? null,
    });
  }

  if (cardData.RarityId) {
    setPokemonRarity({
      value: cardData.RarityId,
      label: cardData.RarityName || "",
    });
  }

  setHoloOverride(cardData.HoloOverride || "");
}

    
  } catch (error) {
    console.error("Error fetching card data:", error);
  }
};




useEffect(() => {
  if (!loading && userId === null && !isAuthenticated) {

    navigate(i18n.language === 'fr' ? '/fr/login' : '/login');
  }
}, [userId, loading, i18n.language]);

const initializeData = async () => {
  console.log("je suis initialise data");

  if (location.state && location.state.card) {
    const card = location.state.card;
    console.log("cardData form location", card);
     
    const isPokemonCard = (card.Type || card.CatalogType) === "Pokemon";
    // sync main type selector
    setSelectedType(card.Type ||card.CatalogType|| "Hockey");

    if (isPokemonCard) {
      // ======== POKÉMON BRANCH ========
      setFormData({
        userCardId: card.id || card.userCardId,
        cardId: card.CardId,                 // still useful if backend expects it
        Name: card.Name || card.CardName || "",
        PlayerId: null,                      // not used for Pokémon
        Type: "Pokemon",

        // Pokémon identity comes from PokemonCards + PokemonSets
        cardName: card.CardName || card.Name || "",
        YearMade: card.YearMade || "",       // if you have it, else ""
        IsRookie: 0,
        IsPatch: 0,
        IsAuto: 0,
        IsJersey: 0,

        Variation: "",                       // hockey-only
        Numbered: card.Numbered || "",       // usually empty, but we keep it
        Uniform: null,                       // hockey-only
        Sets: card.SetId || card.setId || "",
        SetName: card.SetName || "",
        InsertFamilyId: card.InsertFamilyId || "",

        SpecialAttribute: card.SpecialAttribute || "",
        Image: card.ImageFront || card.Image || "",
        ImageBack: card.ImageUserBack || card.ImageBack || "",
        NumberBehind: card.NumberBehind || "",
        Graded: card.Graded === "Graded" ? true : false,
        GradeCompany:
          card.Graded === "Graded" ? card.GradeCompany || "" : "",
        Grade:
          card.Graded === "Graded"
            ? card.Grade || 0
            : 0,

        isPC: card.isPC === "isPC",
        isForSale: card.isForSale === "isForSale",
        isForTrade: card.isForTrade === "isForTrade",
        isOnEbay: card.isOnEbay === "isOnEbay",
        ConditionCard: card.ConditionCard || "",
        EstimateValue: card.EstimateValue || 0,
        PaidPrice: card.PaidPrice || 0,
        Location: card.Location || "",
        SalePrice: card.Price || 0,
        BestOffer: card.BestOffer === 1,
        ShippingTemplate: card.ShippingTemplate || 0,
        Shipping: card.Shipping || 0,
        TradingTemplate: card.TradingTemplate || 0,
        TradeValue: card.TradeValue || 0,

        SeeMore: false,
        // on garde Type cohérent
        Type: "Pokemon",
      });

      // Pré-remplir les selects Pokémon
      if (card.SetId || card.setId) {
        setPokemonSet({
          value: card.SetId || card.setId,
          label: card.SetName || "",
        });
      }

      if (card.CardId) {
        setPokemonCard({
          value: card.CardId,
          label: `${card.CardName || card.Name || ""}${
            card.NumberBehind ? ` #${card.NumberBehind}` : ""
          }`,
          numberBehind: card.NumberBehind ?? null,
          rarityId: card.RarityId ?? null,
          rarityName: card.RarityName ?? null,
        });
      }

      if (card.RarityId || card.RarityName) {
        setPokemonRarity({
          value: card.RarityId || null,
          label: card.RarityName || "",
        });
      }

      setHoloOverride(card.HoloOverride || "");

      // condition lock: même logique que Hockey (si graded, on lock la condition)
      disableConditionSelect =
        card.Graded === "Graded" || card.Graded === true;
    } else {
      // ======== HOCKEY BRANCH (ton ancien code, légèrement nettoyé) ========
      setFormData({
        userCardId: card.id || card.userCardId,
        cardId: card.CardId,
        Name: card.Name || "",
        PlayerId: card.PlayerId,
        Type: card.Type || "Hockey",
        cardName: card.cardName,
        YearMade: card.YearMade,
        IsRookie: card.IsRookie === "Rookie(RC)" ? 1 : 0,
        IsPatch: card.IsPatch === "Patch" ? 1 : 0,
        IsAuto: card.IsAuto === "Auto" ? 1 : 0,
        IsJersey: card.IsJersey === "Jersey" ? 1 : 0,

        Variation: card.IDVariation || "",
        Numbered: card.numbered || "",
        Uniform: card.TeamsId || "",
        Sets: card.setId || "",
        SetName: card.SetName || "",
        InsertFamilyId: card.InsertFamilyId || "",
        SpecialAttribute: card.SpecialAttribute || "",
        Image: card.ImageFront || card.Image || "",
        ImageBack: card.ImageUserBack || card.ImageBack || "",
        NumberBehind: card.NumberBehind || "",
        Graded: card.Graded === "Graded" ? true : false,
        GradeCompany:
          card.Graded === "Graded" ? card.GradeCompany || "" : "",
        Grade:
          card.Graded === "Graded"
            ? card.Grade || 0
            : 0,
        isPC: card.isPC === "isPC",
        isForSale: card.isForSale === "isForSale",
        isForTrade: card.isForTrade === "isForTrade",
        isOnEbay: card.isOnEbay === "isOnEbay",
        ConditionCard: card.ConditionCard || "",
        EstimateValue: card.EstimateValue || 0,
        PaidPrice: card.PaidPrice || 0,
        Location: card.Location || "",
        SalePrice: card.Price || 0,
        BestOffer: card.BestOffer === 1,
        ShippingTemplate: card.ShippingTemplate || 0,
        Shipping: card.Shipping || 0,
        TradingTemplate: card.TradingTemplate || 0,
        TradeValue: card.TradeValue || 0,
        SeeMore: false,
      });

      disableConditionSelect =
        card.Graded === "Graded" || card.Graded === true;

      // optionnel: si tu veux être sûr que le Select Set hockey est synchro
      setSetsCurrentlySelected({
        value: card.setId || 0,
        label: card.SetName || "",
        Set: card.TypeSet || "",
        InsertFamilyId: card.InsertFamilyId || "",
      });
    }
  } else {
    // Pas de location.state → fallback sur le fetch complet
    await fetchCardData(usercardId);
  }
};


  // Function to fetch team data for a player
  const fetchDataTeamsPerPlayer = async (playerId) => {
    try {
      console.log("playerid 499", playerId);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/Get/TeamByPlayerAndRookie?playerId=${playerId}`
         ,{
        withCredentials: true, // ✅ sends cookies/session
      });
      // Log the raw response
      console.log("Raw response:", response.data);
      const uniformList = response.data.map((uniform) => ({
        value: uniform,
        label: FindTheTeamNameById(uniform),
        TeamId: uniform,
      }));
      console.log("uniformlist 506", uniformList);
      return uniformList;
    } catch (error) {
      console.error("Error fetching team data:", error);
      return [];
    }
  };

  // // Usage example
  // const playerId = 123; // Replace with the actual player ID
  // fetchDataTeamsPerPlayer(playerId)
  //   .then((uniformList) => {
  //       setUniformListForThisPlayer(uniformList);
  //   })
  //   .catch((error) => {
  //       console.error('Error setting uniform list:', error);
  //   });

  const fetchCardOptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/variation/getCard`
        ,{
        withCredentials: true, // ✅ sends cookies/session
      });
      const getCards = response.data.map((getCard) => ({
        value: getCard.IdCardVariation,
        label: getCard.cardName,
        name: getCard.fromSet,
      }));

      setVariation(getCards);
    } catch (error) {
      console.log("Error fetching set options:", error.message);
    }
  };

  const fetchCardVariationOptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/variation/getCardVariation`
        ,{
        withCredentials: true, // ✅ sends cookies/session
      });
      const variations = response.data.map((variation) => ({
        value: variation.IDVariation,
        label: variation.variationName,
        name: variation.IdCardVariation,
        isAuto: variation.isAuto,
        isPatch: variation.isPatch,
        numbered: variation.numbered,
        isRookie: variation.isRookie,
        isJersey: variation.isJersey,
      }));

      setCardVariation(variations);
    } catch (error) {
      console.log("Error fetching set options:", error.message);
    }
  };

  useEffect(() => {
    //fetchData();
    //fetchDataSet();
    //fetchCardOptions();
    fetchCardVariationOptions();
    fetchCollections();
    initializeData();
  }, []); // Runs only once on component mount

 

  useEffect(() => {
    const filterCardVari = cardVariation.filter(
      (item) => parseInt(item.name) === parseInt(newVariationName.value)
    );
    console.log("cardVariation", cardVariation);
    console.log("newVariationName", newVariationName);
    setFilteredVariation(filterCardVari);
  }, [newVariationName]);

  useEffect(() => {
    console.log("thisnewcardVariation", thisIsANewVariation);
    console.log("thisnewVariationName", thisIsANewVariationName);
  }, [thisIsANewVariation, thisIsANewVariationName]);

  // const doesItMatchAnExistingCard = async () => {
  //   const PlayerId = formData.PlayerId;
  //   const Type = formData.Type;
  //   const cardVariation = newVariation.value;
  //   const YearMade = formData.YearMade;
  //   const Set = formData.Sets;
    
  //   console.log("Trying doesItMatch", "cardVariation ", newVariation);
  //   console.log("prematching", PlayerId, Type, cardVariation, YearMade, Set);
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE}/api/select/getMatchingCardId`,
  //       {
  //         params: {
  //           PlayerId: PlayerId,
  //           Type: Type,
  //           IDVariation: cardVariation,
  //           Sets: Set,
  //           YearMade: YearMade,
  //         },  
  //       withCredentials: true, // ✅ sends cookies/session
      
  //       }
  //     );

  //     const result = response.data;
  //     console.log("Query Result:", result);
  //     if (result.length > 0) return result[0].CardId;
  //     else return 0;
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

const doesItMatchAnExistingCard = async () => {
  try {
    // ✅ Pokemon: match = PokemonCards.CardId (from picker)
    if (isPokemon) {
      console.log('is pokemon',formData,pokemonCard)
      const PokemonCardId = pokemonCard?.value || formData?.cardId || 0;
      if (!PokemonCardId) return 0;

      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/select/getMatchingCardId`,
        {
          params: { Type: "Pokemon", PokemonCardId },
          withCredentials: true,
        }
      );

      const data = resp.data;
      return Array.isArray(data) && data.length ? data[0].CardId : 0;
    }

    // ✅ Hockey: your existing matching
    const PlayerId = formData.PlayerId;
    const Type = formData.Type;
    const IDVariation = newVariation?.value;
    const YearMade = formData.YearMade;
    const Sets = formData.Sets;

    const resp = await axios.get(
      `${process.env.REACT_APP_API_BASE}/api/select/getMatchingCardId`,
      {
        params: { PlayerId, Type, IDVariation, Sets, YearMade },
        withCredentials: true,
      }
    );

    const data = resp.data;
    return Array.isArray(data) && data.length ? data[0].CardId : 0;
  } catch (error) {
    console.error("doesItMatchAnExistingCard error:", error);
    return 0;
  }
};


  const adapteSetbyFilteredType = async (inputValue) => {
    console.log('formData',formData)
    const TypeOfCard = formData?.Type||selectedType;
  
    if (!TypeOfCard || inputValue.length < 3) return; // Ensure both TypeOfCard is selected and input has 3+ characters
  
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/searchbar/sets?TypeOfCard=${TypeOfCard}&searchTerm=${inputValue}`
       ,{
        withCredentials: true, // ✅ sends cookies/session
      } );
      
      console.log("API Response:", response.data); // Log the response to check its format
  
      // Ensure response.data is an array before mapping
      if (Array.isArray(response.data)) {
        const filteredOptions = response.data.map((set) => ({
          value: set.SetId,
          label: set.SetName,
          InsertFamilyId:set.InsertFamilyId,
        }));
  
        setFilteredSets(filteredOptions); // Update the filtered sets based on the type and search term
      } else {
        console.error("Unexpected API response format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching filtered sets:", error);
    }
  };

  // useEffect(() => {
  //   const TypeOfCard = formData.Type;
  //   console.log("formData.Type,early", TypeOfCard);
  //   const filteredOptions = setsSelected.filter(
  //     (option) => option.Set === TypeOfCard
  //   );
  //   console.log("early-setFilteredSets");
  //   setFilteredSets(filteredOptions);
  // }, [setsSelected]);

  //Handle Base64 conversion
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  // Extracts the year from a set name string
  function getYearFromSet(str) {
    const year = str.substring(0, 4); // Get the first 4 characters of the string
    return year;
  }

  //Slow the select input change

  // const debouncedFetchData = debounce((inputValue) => {
  //   fetchData(inputValue);
  // }, 300);

  // const handleInputChangeQuicker = (inputValue) => {
  //   console.log("still out");
  //   if (inputValue && inputValue.length >= 3) {
  //     // Perform the search for players
  //     console.log("is");
  //     debouncedFetchData(inputValue);
  //   }
  // };

  // Handles input change for the form
  const handleInputChange = async (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === "checkbox" ? checked : value;
    //ToBeMade if(name='playernotfound'&&)
    console.log("Name : ", name, "Value: ", value, "type :", type);
    if (name === "Graded" && value === "false") {
      await setFormData((prevData) => ({
        ...prevData,
        Graded: false,
        Grade: 0,
        GradeCompany: "",
      }));
    }
    if (name === "Graded" && value === "true") {
      await setFormData((prevData) => ({
        ...prevData,
        Graded: true,
        Grade: 10,
        GradeCompany: "PSA",
      }));
    }

    await setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));

    const newErrors = validateForm();

    if (Object.keys(newErrors).length > 0) {
      // Display all errors at once
      setErrors(newErrors);
      return; // Prevent form submission
    }
  };

const handleNumberedChange = (e) => {
  const onlyDigits = e.target.value.replace(/\D/g, ""); // strip anything that's not 0–9
  handleInputChange({ target: { name: "Numbered", value: onlyDigits,type:'text' } });
};

  // Handles input change for the form
  const handleToggleButtonChange = (name) => {
    setFormData((prevData) => {
      // If the button is related to the 'Graded' field, handle it specially
      if (name === "Graded") {
        console.log("Pre-Graded", formData);
        return {
          ...prevData,
          [name]: (prevData[name]==='Graded'||prevData[name]===true)?false:true,
          // When graded is toggled, set additional properties
          Grade: !prevData[name] ? 10 : 0,
          GradeCompany: !prevData[name] ? "PSA" : "",
          
        };
      }
      // For all other toggles, just flip the boolean value
      return {
        ...prevData,
        [name]: !prevData[name],
      };
    });
  };

  useEffect(() => {
    if (
      searchSuggestions.length > 0 &&
      searchSuggestions !== currentSuggestions
    ) {
      console.log("suggestion should be there", searchSuggestions);
      setCurrentSuggestions(searchSuggestions);
      setIsSuggestionOpen(true);
    } else {
      setIsSuggestionOpen(false);
      setCurrentSuggestions([]);
    }
  }, [searchSuggestions]);

  useEffect(() => {
    if (
      searchSuggestions.length > 0 &&
      searchSuggestions === currentSuggestions
    ) {
      console.log("currentSuggestions should be there", currentSuggestions);
      // setForceRerender((prev) => !prev);
    }
  }, [currentSuggestions]);


  const fetchSuggestions2 = async (inputValue) => {
    setIsFetching(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/searchbar/DeepSearch?searchTerm=${encodeURIComponent(inputValue)}&type=${encodeURIComponent(selectedType)}`,
      {
        withCredentials: true, // ✅ sends cookies/session
      }
      );

      const suggestions = mapResponseToOptions(response.data, "DeepSearch");
      console.log("0000 suggestion", suggestions);

      return suggestions || []; // Return the array of suggestions or an empty array
    } catch (error) {
      console.error("Error fetching suggestions: v2", error);
      setSearchSuggestions([]);
      return []; // Return an empty array in case of an error
    } finally {
      setIsFetching(false);
    }
  };

  const handleInputChange2 = (inputValue, validSearch) => {
    setInputValue(inputValue);
    // Split the input value into words using spaces as separators
    // Check if the last word is at least 3 characters long
    if (inputValue.length >= 4 && validSearch != false) {
      // Split the input value into words using spaces as separators
      const words = inputValue.split(" ");
      // Get the last word entered by the user
      const lastWord = words[words.length - 1];

      if (lastWord.length >= 3) {
        clearTimeout(fetchTimeout);

        // Set a new timeout to fetch suggestions after a short delay
        fetchTimeout = setTimeout(() => {
          fetchSuggestions2(inputValue)
            .then((suggestions) => {
              setSearchSuggestions(suggestions);
            })
            .catch((error) => {
              console.error("Error handling input change:", error);
              setSearchSuggestions([]);
            });
        }, 300); // Adjust the delay (in milliseconds) as needed
      } else {
        // Clear suggestions if the input is less than 3 characters
        setSearchSuggestions([]);
        setIsSuggestionOpen(false);
      }
    } else {
      setCurrentSuggestions([]);
      setIsSuggestionOpen(false);
    }
  };
  const handleSearch2 = async (selectedOption) => {
    try {
      console.log("selectedOption 214", selectedOption);
      if (selectedOption) {
        if (selectedOption.value > 0 && selectedOption.value !== "") {
          const getResultFromSelectedSuggestion = await handleGetMatchingResult(
            selectedOption.value
          );
          setCurrentSuggestions([selectedOption]); // Ensure this is an array
          console.log(
            `Search results for ${selectedOption.value}:`,
            getResultFromSelectedSuggestion
          );
          if (getResultFromSelectedSuggestion.length > 0) {
            console.log("je suis ici 576", getResultFromSelectedSuggestion);

          const dataFromCardId =
  selectedType === "Pokemon"
    ? mapPokemonCardDataToFormDataFromSearch(getResultFromSelectedSuggestion[0])
    : mapCardDataToFormDataFromSearch(getResultFromSelectedSuggestion[0]);

const newCard = dataFromCardId;

setPokemonSetInput(newCard.SetName);

setPokemonCardInput({ value: newCard.cardId, label: newCard.cardName });
if (selectedType !== "Pokemon") {
  if (newCard?.Name) {
    handlePlayerInputChange(newCard.Name, true);
  }
  if (newCard?.SetName) {
    handleSetInputChange(newCard.SetName);
    setSetSearchTerm(newCard.SetName);
  }
  if (newCard?.cardName) {
    handleCardInputChange(newCard.cardName);
    setShouldAutoSelectVariation(true);
  }
}


 setPreviewImage(newCard.Image);
            // // Update formData with the mapped data
             setFormData(dataFromCardId);
  
          }
          setIsSuggestionOpen(false);
        }
      } else {
        setSearchSuggestions([]);
        setCurrentSuggestions([]); // Ensure this is cleared to an empty array
        setIsSuggestionOpen(false);
      }
    } catch (error) {
      console.error("Error handling input change:", error);
    }
  };



const handleGetMatchingResult = async (cardId) => {
  if (cardId !== null) {
    try {
      console.log(`getting result for cardId`, cardId);

      const endpoint =
        selectedType === "Pokemon"
          ? `${process.env.REACT_APP_API_BASE}/api/searchbar/getPokemonDataFromCardId/${cardId}`
          : `${process.env.REACT_APP_API_BASE}/api/searchbar/getDataFromCardId/${cardId}`;

      const response = await axios.get(endpoint, {
        withCredentials: true,
      });

      console.log(`Search results for ${cardId}:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error fetching ${selectedType} search results:`, error);
      return [];
    }
  }

  return [];
};

  // function ApplyPatch(label) {
  //   const parts = label.split(" - ");
  //   if (parts.length > 4) {
  //     const patches = parts.slice(4);
  //     return (
  //       <div className="Searchcardisfor flex-h">
  //         {patches.map((patch, index) => (
  //           <div
  //             key={index}
  //             className="Searchpatch"
  //             style={{ marginTop: "15px" }}
  //           >
  //             <p style={{ fontSize: "15px" }}>{patch}</p>
  //           </div>
  //         ))}
  //       </div>
  //     );
  //   }
  //   return null; // Return null if there are no patches to display
  // }
  function ApplyPatch(label) {
    // Split the label by " - ", but preserve years like 2018-19
    const parts = label.split(" - ").filter((part) => !/^\d{4}-\d{2}$/.test(part));
    // Ensure at least 4 parts before taking patches
    if (parts.length >= 4) {
      const patches = parts.slice(3);      
      return (
        <div className="card-isfor">
          {patches.map((patch, index) => (
            <div key={index} className="pill">
              {patch}
            </div>
          ))}
        </div>
      );
    }
    return null; // Return null if there are no patches to display
  }
  const fetchSuggestions = async (inputValue, typeT) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/searchbar/custom/${typeT}?searchTerm=${inputValue}`  ,{
        withCredentials: true, // ✅ sends cookies/session
      }
      );
  
      const suggestions = mapResponseToOptions(response.data, typeT);
  
      // Use switch statement to handle different state setters
      switch (typeT) {
        case "player":
          setOptions(suggestions); // Set options for player
          break;
        case "card":
                    const filteredSuggestions = suggestions.filter((item) => {
  // Always exclude if InsertFamilyId is empty or null
  if (!item.InsertFamilyId) return false;

  // If the variation name includes 'Base', check for matching InsertFamilyId
  if (item.label?.toLowerCase().includes('base')) {
    return item.InsertFamilyId === setsCurrentlySelected?.InsertFamilyId;
  }
  // Otherwise, include the item
  return true;
});
setVariation(filteredSuggestions); // Set options for card
          break;
        case "set":
          setFilteredSets(suggestions); // Set options for sets
          break;
        default:
          console.error("Unknown typeT:", typeT);
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };
useEffect(() => {
  if(newPlayerName.length===3&&newPlayerName[1]===' '){
  setSelectKey(Date.now());} // Set a new key to force re-render
}, [options]);
 
  const handlePlayerInputChange = useCallback(
    debounce((inputValue, skipSetPlayerName) => {
      if (inputValue.length >= 3) {
        if (!skipSetPlayerName) {
          setNewPlayerName(inputValue);
        }
        fetchSuggestions(inputValue, "player");
      }
    }, 300),
    []
  );
   const handleSetInputChange = useCallback(
     debounce((inputValue) => {

       if (inputValue.length >= 3) {
         adapteSetbyFilteredType(inputValue);
         setSetsCurrentlySelected({value:inputValue,label:inputValue})
       } 
     }, 300), [] // Empty dependency array to avoid re-creating debounce function
   );
   
   // ✅ Debounce the card input change function
   const handleCardInputChange = useCallback(
     debounce((inputValue) => {
       if (inputValue.length >= 3) {
         fetchSuggestions(inputValue, "card");
       }
     }, 300), []
   );

  const handleNumericInputChange = (event) => {
    const { name, value } = event.target;
    const regex = /^[0-9]*\.?[0-9]*$/; // Allow numbers and decimal points
  
    if (regex.test(value)) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  useEffect(() => {

    console.log('Je trigger sans raison ')
    if (!location?.state?.card) return;
  
    //setPlayerInput(location.state.card.Name);
    handlePlayerInputChange(location.state.card.Name,true);
  
    //setSetInput(location.state.card.SetName);
    handleSetInputChange(location.state.card.SetName);
    setSetSearchTerm(location.state.card.SetName);
    //setCardNameInput(location.state.card.cardName);
    handleCardInputChange(location.state.card.cardName);
    
   
    setShouldAutoSelectVariation(true);
    //setVariationInput(location.state.card.variationName);
   // handleVariationInputChange(location.state.card.variationName);
  }, []);

  const mapResponseToOptions = (data, typeT) => {
    return data.map((item) => {
      console.log("item", item);
      switch (typeT) {
        case "player":
          return {
            value: item.PlayerId,
            label: item.Name,
            rookieYear: item.RookieYear,
            rookieTeam: item.TeamId,
          };
        case "set":
          return { value: item.setId, label: item.SetName,InsertFamilyId:item.InsertFamilyId  };
        case "card":
          return { value: item.IdCardVariation, label: item.cardName,InsertFamilyId:item.InsertFamilyId  };
        case "variation":
          return { value: item.IDVariation, label: item.variationName };
        case "DeepSearch":
          console.log("item 48", item);
          console.log("item 4 v2", item.CardId, item.SearchTitle, item.Image);

          return {
            value: item.CardId,
            label: item.SearchTitle,
            Image: item.Image,
          };
      }
    });
  };
  //Handle image change   <img src="data:image/png;base64,iVBORw0KG..." alt="Base64 Image" />
 
  const [isDragging, setIsDragging] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  
  const handleDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy"; // Show the copy cursor
  };
  
  const handleDrop = async (event, fieldName) => {
    event.preventDefault();
    setIsDragging(false);
  
    const file = event.dataTransfer.files[0]; // Assuming single file upload
    if (file) {
      await handleImageChange({ target: { name: fieldName, files: [file] } }); // Mock event
    }
  };
  
  
  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
        const previewUrl = URL.createObjectURL(file); // ✅ Generate temporary URL

        if (event.target.name === "Image") {
            setFormData((prevData) => ({
                ...prevData,
                Image: file, // ✅ Store File object for upload
            }));
            setPreviewImage(previewUrl); // ✅ Store preview URL for display
        } else if (event.target.name === "ImageBack") {
            setFormData((prevData) => ({
                ...prevData,
                ImageBack: file, // ✅ Store File object for upload
            }));
            setPreviewImageBack(previewUrl); // ✅ Store preview URL for display
        }
    }
};
  // Handles Player/Set dropdown selection
  const handleChange = (selectedOption) => {
    if (selectedOption) {
      console.log(`Option selected:`, selectedOption);
      setRookieYearForThisPlayer(0);
      // get the uniformlist
      const playerId = parseInt(selectedOption.value); // Replace with the actual player ID
      console.log("playerId 737", playerId);
      fetchDataTeamsPerPlayer(playerId)
        .then((uniformList) => {
          setUniformListForThisPlayer(uniformList);
          setUniformCurrentlySelected(uniformList[0]);
        })
        .catch((error) => {
          console.error("Error setting uniform list:", error);
        });

      // setPlayerNameTempo(selectedOption)
      setFormData((prevData) => ({
        ...prevData,
        PlayerId: selectedOption.value,
        Name: selectedOption.label,
      }));
      setNewPlayerName(selectedOption);
      if (errors.PlayerId) {
        // Remove the error for PlayerId
        setErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          delete updatedErrors.PlayerId;
          return updatedErrors;
        });
      }
      if (selectedOption.rookieYear === null) {
        setRookieYearForThisPlayer(0);
      } else {
        setRookieYearForThisPlayer(selectedOption.rookieYear || 0);
        // ✅ Pre-fill the input field in the next select
        setSetsCurrentlySelected({label:selectedOption.rookieYear?.toString() || "",value:''});
        // ✅ Trigger the database search
        handleSetInputChange(selectedOption.rookieYear?.toString() || "");
      }
    } else {
      console.log("player name as been deleted");
      setNewPlayerName("");
      setRookieYearForThisPlayer(0);
      setFormData((prevData) => ({
        ...prevData,
        PlayerId: 0,
      }));
    }
    focusNextField("set");
    setOpenSelect("set")
  };

  const handleChangeUniform = (selectedOption) => {
    if (selectedOption) {
      console.log(`Option selected:`, selectedOption);
      setFormData((prevData) => ({
        ...prevData,
        uniform: selectedOption.value,
      }));
      setUniformCurrentlySelected(selectedOption);
    }
  };

  const handleChangeSet = async(selectedOption) => {
    console.log(`Option selected:`, selectedOption);
    const YearReturn = getYearFromSet(selectedOption.label);
    console.log("currentlyselected :", setsCurrentlySelected);
    setSetsCurrentlySelected(selectedOption);
    const setId = selectedOption.value
    console.log(formData.Type);
    console.log(formData.Type);
    setFormData((prevData) => ({
      ...prevData,
      Sets: setId,
      SetName: selectedOption.label,
      YearMade: YearReturn,
      InsertFamilyId:selectedOption.InsertFamilyId,
    }));
    if (errors.Sets) {
      // Remove the error for PlayerId
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors.Sets;
        return updatedErrors;
      });
    }

         // 👉 NEW: Fetch familyIds and variations from backend
  try {
    const res = await fetch(`${process.env.REACT_APP_API_BASE}/getFamilyAndVariations/${setId}`, {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
    const variations = await res.json();

    const formatted = variations.map(item => ({
      value: item.IdCardVariation,
      label: item.cardName,
      InsertFamilyId:item.InsertFamilyId,
    }));
    console.log('formatted variationname',formatted)
    //setCardVariation(formatted);
       const filteredSuggestions = formatted.filter((item) => {
  // Always exclude if InsertFamilyId is empty or null
  if (!item.InsertFamilyId) return false;

  // If the variation name includes 'Base', check for matching InsertFamilyId
  if (item.label?.toLowerCase().includes('base')) {
    return item.InsertFamilyId === selectedOption?.InsertFamilyId;
  }

  // Otherwise, include the item
  return true;
});

setVariation(filteredSuggestions);

  } catch (err) {
    console.error("Error fetching variations from set family:", err);
  }
    focusNextField("variationName");
    setOpenSelect("variationName")
  };

  // Handles Player/Set dropdown selection
  const handleChangeVariationName = (selectedOption) => {
    if (selectedOption) {
      const newCard = selectedOption;
      setNewVariationName(newCard);
      
      console.log("onchangefiltervariationName", newCard);
      setNewVariationNameId(selectedOption.value);
      setFormData((prevData) => ({
        ...prevData,
        cardName: newCard.label,
      }));
      if (errors.cardName) {
        // Remove the error for PlayerId
        setErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          delete updatedErrors.cardName;
          return updatedErrors;
        });
      }
    // } else {
    //   const newCard = [0, "", "notusefull"];
    //   setNewVariationName(newCard);
    //   setNewVariationNameId(0);
    //   setFormData((prevData) => ({
    //     ...prevData,
    //     numbered: "",
    //     IsAuto: false,
    //     IsJersey: false,
    //     IsPatch: false,
    //     IsRookie: false,
     
    //     variationName: "",
    //   }));
     }
    focusNextField("variation");
    setOpenSelect("variation");
  };


  // useEffect(() => {
  //   if (shouldAutoSelectVariation && variation.length > 0) {
  //     handleChangeVariationName(variation[0]);
  //     setShouldAutoSelectVariation(false);
  //   }
  // }, [variation, shouldAutoSelectVariation]);
  {
    /*value: variation.IDVariation,
    label: variation.variationName,
name: variation.IdCardVariation,*/
  }

  const handleChangeVariation = (selectedOption) => {
    if (selectedOption) {
      setNewVariation(selectedOption);
      setFormData((prevData) => ({
        ...prevData,
        Variation: selectedOption.value,
        IsAuto: selectedOption.isAuto,
        IsJersey: selectedOption.isJersey,
        IsRookie: selectedOption.isRookie,
        Numbered: selectedOption.numbered,
        IsPatch: selectedOption.isPatch,
      }));
      console.log("onchangefiltervariation", selectedOption);
      setVariationLocked(true);
      if (errors.Variation) {
        // Remove the error for PlayerId
        setErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          delete updatedErrors.Variation;
          return updatedErrors;
        });
      }
    } else {
      const newCard = [0, "", 0];
      setNewVariation(newCard);
      setVariationLocked(false);
      setFormData((prevData) => ({
        ...prevData,
        Numbered: "",
        IsAuto: false,
        IsJersey: false,
        IsPatch: false,
        IsRookie: false,
       
        variationName: "",
      }));
    }
    setOpenSelect('null')
    focusNextField("null");
  };


  const initialiseValues = async () => {
    // Check if location.state and location.state.card exist, else set defaults
    const card = location?.state?.card || {
      IDVariation: 0,
      variationName: '',
      IdCardVariation: 0,
      RookieYear: 0,
      PlayerId: 0,
    };
  
    // Handle variation name based on existing or fetched data
    //handleChangeVariationName(newVariationName);
  
    // Safely set the variation details with fallback defaults
    setNewVariation({
      value: card.IDVariation,
      label: card.variationName,
      name: card.IdCardVariation,
    });
  
    // Set rookie year for the player
    setRookieYearForThisPlayer(card.RookieYear);
  
    // Safely get the playerId and attempt fetching uniforms if playerId is valid
    const playerId = parseInt(card.PlayerId, 10);
  
    if (playerId > 0) {
      try {
        const uniformList = await fetchDataTeamsPerPlayer(playerId);
        setUniformListForThisPlayer(uniformList);
        if (uniformList.length > 0) {
          setUniformCurrentlySelected(uniformList[0]);
        } else {
          setUniformCurrentlySelected(null); // Handle case where there is no uniform
        }
      } catch (error) {
        console.error("Error setting uniform list:", error);
      }
    } else {
      console.error("Invalid or missing playerId:", playerId);
    }
  
    // Log data for debugging purposes
    console.log("formData", formData);
    console.log("Initialise completed", newVariationName);
  };
  
  

  useEffect(() => {
    initialiseValues();
  }, []);
  const validateForm = () => {
    const newErrors = {};

    if (!selectedType || selectedType === "") {
      newErrors.Type = "*Type is required.*";
    }

    if ((newPlayerName === "" || formData?.PlayerId === "")&&!isPokemon) {
      newErrors.PlayerId = "*Player Id is required*.";
    }

    if (!setsCurrentlySelected || !setsCurrentlySelected.value) {
      newErrors.Sets = "Sets is required.*";
    }

    if (
      (!formData?.YearMade ||
      parseInt(formData?.YearMade) <= 1850 ||
      parseInt(formData?.YearMade) >= parseInt(Date.getFullYear))&&!isPokemon
    ) {
      newErrors.YearMade = "*Year Made is required.*";
    }
    if (!newVariationName || newVariationName[1] === "") {
      newErrors.cardName = "*Card Name is required.*";
    }
    if (!newVariation || newVariation[1] === "") {
      newErrors.Variation = "*Variation is required.*";
    }
    return newErrors;
  };

  //Ici on va faire apparaitre des checkboxs pour les variations (Card name(setName avec substring pour extraire ce que je veux) - Young guns - Fwa-p - The cup - opc plat- Ice/99)
  // Handles form submission
  useEffect(() => {
    console.log("error live ", errors);
  }, [errors]);


// 🔁 Debounced fetch pour les SETS Pokémon
const fetchPokemonSets = useMemo(() => debounce(async (term) => {
  if (!term || term.length < 2) {
    setPokemonSetOptions([]);
    return;
  }

  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_BASE}/api/pokemon/sets?searchTerm=${encodeURIComponent(term)}`,
      { withCredentials: true }
    );

    const opts = (data || []).map((s) => ({
      value: s.value ?? s.SetId,
      label: s.label ?? s.SetName,
    }));

    setPokemonSetOptions(opts);
  } catch (e) {
    console.error("fetchPokemonSets error", e);
    setPokemonSetOptions([]);
  }
}, 300), []);

// cleanup du debounce
useEffect(() => {
  return () => {
    fetchPokemonSets.cancel && fetchPokemonSets.cancel();
  };
}, [fetchPokemonSets]);

// quand le texte du select Set change → on déclenche la recherche
useEffect(() => {
  if (!isPokemon) return;
  fetchPokemonSets(pokemonSetInput);
}, [pokemonSetInput, isPokemon, fetchPokemonSets]);


  
// 🔁 Debounced fetch pour les CARTES Pokémon (dans un set)
const fetchPokemonCards = useMemo(
  () =>
    debounce(async (setId, term = "") => {
      try {
        if (!setId) {
          setPokemonCardOptions([]);
          return;
        }

        const API = process.env.REACT_APP_API_BASE;
        const hasQuery = (term?.trim()?.length ?? 0) >= 2;

        const url = hasQuery
          ? `${API}/api/pokemon/cards?setId=${setId}&q=${encodeURIComponent(term)}`
          : `${API}/api/pokemon/cards?setId=${setId}`;

        const res = await fetch(url, { credentials: "include" });
        const data = await res.json();

        const opts = (data || []).map((c) => ({
          value: c.CardId ?? c.value,
          label:
            c.label ??
            `${c.CardName || c.Name || "??"} ${
              c.NumberBehind ? `#${c.NumberBehind}` : ""
            }`,
          numberBehind: c.NumberBehind ?? null,
          rarityId: c.RarityId ?? null,
          rarityName: c.RarityName ?? null,
        }));

        setPokemonCardOptions(opts);
      } catch (e) {
        console.error("fetchPokemonCards error", e);
        setPokemonCardOptions([]);
      }
    }, 250),
  []
);

// cleanup debounce
useEffect(() => {
  return () => {
    fetchPokemonCards.cancel && fetchPokemonCards.cancel();
  };
}, [fetchPokemonCards]);

// Quand le set sélectionné OU le texte de recherche de carte change
useEffect(() => {
  if (!isPokemon) return;
  if (!pokemonSet?.value) {
    setPokemonCardOptions([]);
    return;
  }
  fetchPokemonCards(pokemonSet.value, pokemonCardInput);
}, [isPokemon, pokemonSet, pokemonCardInput, fetchPokemonCards]);

  
  // trigger fetch when user types (and a set is chosen)
  // useEffect(() => {
  //   if (pokemonSet?.value) fetchPokemonCards(pokemonSet.value, pokemonCardInput);
  //   else setPokemonCardOptions([]);
  // }, [pokemonCardInput, pokemonSet, fetchPokemonCards]);
  
  useEffect(() => {
    if (pokemonSet?.value) {
      setPokemonCardInput("");                 // clear any previous query
      fetchPokemonCards(pokemonSet.value, ""); // fetch entire set
      // optional: auto-focus & open the Card select
      if (selectRefs?.variationName?.current) {
        selectRefs.variationName.current.focus?.();
        selectRefs.variationName.current.onMenuOpen?.();
      }
    } else {
      setPokemonCardOptions([]);
    }
  }, [pokemonSet, fetchPokemonCards]);
  
  // keep these tiny controlled inputs for the async selects
  
  
  const clearPokemon = () => {
    setPokemonSet(null);
    setPokemonCard(null);
    setPokemonRarity(null);
    setHoloOverride('');
  };
  
  // whenever type changes, reset pokemon fields to avoid stale state
  useEffect(() => {
    if (selectedType !== "Pokemon") clearPokemon();
  }, [selectedType]);
  
  // Small helper to format an eBay query for Pokémon (used by your existing button if any)
  function buildPokemonEbayQuery() {
    const parts = [];
    if (pokemonSet?.label) parts.push(pokemonSet.label);
    if (pokemonCard?.label) parts.push(pokemonCard.label);
    if (formData?.Graded && formData?.GradeCompany && formData?.Grade > 0) {
      parts.push(`${formData.GradeCompany} ${formData.Grade}`);
    }
    if (holoOverride) parts.push(holoOverride);
    return parts.join(" ");
  }
  
  
  


  //----------------------------------------Collection
  function fetchCollections() {
    fetch(`${process.env.REACT_APP_API_BASE}/api/collection/getCollectionUser/${userId}`, {
    method: 'GET',
    credentials: 'include',
  })
      .then((response) => response.json())
      .then((data) => {
        console.log("Juste avant fetchCollections", data);
        // Set state with default collection followed by fetched data
        setCollections([
          { ListId: 0, Title: "NotAssigned", collectionCount: 0 },
          ...data,
        ]);
      })
      .catch((error) => {
        console.error("Error fetching collections:", error);
      });
  }
  function handleCreateNewCollection(event, isConfirmed) {
    event.preventDefault(); // This stops the form from submitting

 

    console.log("Creating a collection and assigning to it");
    const currentTitle = createNewCollectionTitle?.trim();// Replace with your input or dynamic value
  
 if (!isConfirmed || !currentTitle || currentTitle.length === 0) {
    toast.error(t("InvalidCollectionTitle"));
    return;
  }

    if (isConfirmed && currentTitle) {
      fetch(`${process.env.REACT_APP_API_BASE}/api/collection/add/collection`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
          credentials: "include",
        body: JSON.stringify({ userId, currentTitle, liveCsrfToken }), // Include CSRF token in the request body
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.listId) {
            const { listId } = data;
            console.log("Created list ID:", listId);
            console.log("Created list Title:", currentTitle);
  
  
            setSelectedCollectionLive({
            ListId: listId,
    value :listId,
    Title: `${currentTitle} (0)`,
    label: currentTitle,
    collectionCount: 0
          });
            setCreateNewCollectionTitle("");
            setAllowCreateNewCollection(false);
            fetchCollections(); // Fetch collections after creating
          } else {
            console.error("Error creating list:", data.error);
          }
        })
        .catch((error) => {
          console.error("Error creating list:", error);
        });
    } else {
      console.error("Collection title is either empty or not valid");
    }
  }
  
  // function handleRenameCollection(isConfirmed) {
  //   console.log("renaming the collection with id:", selectedCollectionLive);
  //   const collectionTitle = renameCollectionTitle; // Replace with your input or dynamic value
  //   if (isConfirmed) {
  //     fetch("https://projet-collect-v1-production.up.railway.app/api/collection/rename/watchlist", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         userId,
  //         collectionTitle,
  //         selectedCollectionLive,
  //       }),
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         const { watchlistId } = data;

  //         console.log("Renamed list", " Title:", collectionTitle);
  //         setRenameCollectionTitle("");
  //         setConfirmationVisibleRenameWatchList(false);
  //       })
  //       .catch((error) => {
  //         console.error("Error renaming list:", error);
  //       });
  //   }
  // }
  //-----------------------------------------------FetchData(Post)/AddCardToCollection---------------------------------------------------
  // Function to insert into cards_cardslist table
  async function insertIntoCardsCardsList(listId, thisUserCardId) {
    try {

      console.log('dedans insertIntoCardsCardsList listId, thisUserCardId',listId, thisUserCardId,)
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/collection/add/card`,
        {
          listId,
          cardIds: [thisUserCardId],
          liveCsrfToken,
          userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": liveCsrfToken,
          },
          withCredentials: true,
        }
      );
  
      if (response.data.success) {
        toast.success(t("Card assigned to collection"));
      }
    } catch (error) {
      toast.error(t("Error adding card to collection"));
      console.error("Error inserting card into cards_cardslist:", error);
    }
  }

  function handleCancelCreateCollection() {
    setAllowCreateNewCollection(false);
    setConfirmationVisibleCreateNewCollection(false);
    setCreateNewCollectionTitle("");
    //  setSelectedAction1("Select Action null");
  }

  function handleAssignToCollectionCancelButtonClick() {
    //setSelectedAction1("Select Action null");
  }

  // function handleCancelRenameCollection() {
  //   setConfirmationVisibleRenameWatchList(false);
  //   // setCreateNewCollectionTitle('');
  // }
  // const handleRenameButtonClick = () => {
  //   setAllowCollectionRename(true);
  // };
  // function displayCreateCollectionForm() {
  // Render the form elements (dropdown and confirm button)
  const handleCreateNewButtonClick = () => {
    setAllowCreateNewCollection(true);
  };

  const createCollectionLabelNewCollection = (
    <div>
      <label htmlFor="createCollection">Creating a new collection</label>
    </div>
  );
  const collectionNameInputNewCollection = (
    <input
      type="text"
      value={createNewCollectionTitle}
      onChange={(e) => setCreateNewCollectionTitle(e.target.value)}
      placeholder="New collection name"
      maxLength={40}
    />
  );
  /*handleCreateNewCollection()*/
  const confirmButtonNewCollection = (
    <button type="button" onClick={(e) => handleCreateNewCollection(e, true)}>
      Confirm
    </button>
  );
  const cancelButtonNewCollection = (
    <button type="button" onClick={() => handleCancelCreateCollection()}>
      Cancel
    </button>
  );

  //   return (
  //     <div>
  //       {createCollectionLabelNewCollection}
  //       {collectionNameInputNewCollection}
  //       {confirmButtonNewCollection}
  //       {cancelButtonNewCollection}
  //     </div>
  //   );
  // }

  // function displayRenameCollectionForm() {
  //   // Render the form elements (dropdown and confirm button)
  //   const renameCollectionLabel = (
  //     <div>
  //       <label htmlFor="renameCollection">Rename this collection</label>
  //     </div>
  //   );
  //   const collectionNameInput = (
  //     <input
  //       id="id"
  //       type="text"
  //       value={renameCollectionTitle}
  //       onChange={(e) => setRenameCollectionTitle(e.target.value)}
  //       placeholder="Enter a new name for this collection"
  //     />
  //   );
  //   /*handleCreateNewCollection()*/
  //   const confirmButton = (
  //     <button onClick={() => handleRenameCollection(true)}>Confirm</button>
  //   );
  //   const cancelButton = (
  //     <button onClick={() => handleCancelRenameCollection()}>Cancel</button>
  //   );
  //   return (
  //     <div>
  //       {renameCollectionLabel}
  //       {collectionNameInput}
  //       {confirmButton}
  //       {cancelButton}
  //     </div>
  //   );
  // }

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   setIsLoading(true);

  //   const newErrors = validateForm();

  //   if (Object.keys(newErrors).length > 0) {
  //     // Display all errors at once
  //     setErrors(newErrors);
  //     toast.error(t("Please fill in all required fields"));
  //     return; // Prevent form submission
  //   }
  //   const AccesUserId = userId;
  //   const cardIdMatch = await doesItMatchAnExistingCard();
  //   let newOrNotCardId = formData.cardId;
  //   console.log('location?.state?.card.CardId',location?.state?.card)
  //   console.log('cardIdMatch',cardIdMatch)
  //   console.log(" what is the found it by matching", newOrNotCardId);
  //   console.log("formDat a ", formData);
  //   //userCardId
  //   try {
  //     const userCardFormData = {
  //       userId: AccesUserId,
  //       SpecialAttribute:formData.SpecialAttribute,
  //       Image: formData.Image,
  //       ImageBack: formData.ImageBack,
  //       Graded: formData.Graded === true,
  //       GradeCompany: formData.GradeCompany,
  //       Grade: formData.Grade,
  //       isPC: formData.isPC,
  //       isForSale: formData.isForSale,
  //       isForTrade: formData.isForTrade,
  //       isOnEbay: formData.isOnEbay,
  //       ConditionCard: formData.ConditionCard,
  //       EstimateValue: formData.EstimateValue,
  //       PaidPrice: formData.PaidPrice,
  //       Location: formData.Location,
  //     };
  //     if (location?.state?.card.CardId === cardIdMatch) {
  //       console.log("on est dans edit same card avec foundid");
  //       const response = await axios.put(
  //         "https://projet-collect-v1-production.up.railway.app/api/update/userCard/sameCardId",
  //         {
  //           userId: AccesUserId,
  //           userCardId: formData.userCardId,
  //           cardId: formData.cardId,
  //           userCardFormData: userCardFormData,
  //         }
  //       );
  //       setSuccessMessage("Update has been made - SameCard");
  //     } else if (cardIdMatch !== 0 && cardIdMatch !== location?.state?.card.CardId && isAddingNewCard===false) {
  //       //update usercard avec new cardId
  //       console.log(
  //         "questce que je fais ici bordel : cardIdMatch :",
  //         cardIdMatch,
  //         " mon cardId :",
  //         formData.cardId
  //       );
  //       //call function update cardId where userId =adsa and userId = aasdad

  //       UpdateCardIdFromUserCardId(
  //         cardIdMatch,
  //         location?.state?.card.id,
  //         location?.state?.card.CardId
  //       );
  //     } else if (cardIdMatch === 0 || isAddingNewCard) {
  //       //function to create a new et retourn le cardId pour l'update
  //       console.log("Tu shits is not a match va faire le full create");
  //       console.log(
  //         "thisIsANewPlayer ",
  //         thisIsANewPlayer,
  //         "thisIsANewVariationName ",
  //         thisIsANewVariationName,
  //         ""
  //       );
  //       let newPlayerId = 0;
  //       let playerId = [0];
  //       const lastplayerId = 0;
  //       setFormData((prevData) => ({
  //         ...prevData,
  //       }));
  //       if (thisIsANewPlayer) {
  //         try {
  //           const sport = formData.Type;
  //           const tempoNewPlayer = {
  //             Type: sport,
  //             PlayerName: newPlayerName.label,
  //           };
  //           console.log(
  //             "tempo avant insert",
  //             tempoNewPlayer,
  //             "is new ?",
  //             thisIsANewPlayer
  //           );
  //           console.log("player not found to true");
  //           const responseInsertPlayerNotFound = await axios.post(
  //             `${process.env.REACT_APP_API_BASE}/api/add/NewPlayer`,
  //             tempoNewPlayer
  //           );
  //           newPlayerId = responseInsertPlayerNotFound.data;
  //           console.log(responseInsertPlayerNotFound.data);
  //           const preInsert = {
  //             tableName: "players",
  //             id: newPlayerId,
  //             UserId: userId,
  //           };
  //           const responseSendToAdmin = await axios.post(
  //             `${process.env.REACT_APP_API_BASE}/api/admin/InsertIntoApprobation`,
  //             preInsert
  //           );
  //           setFormData((prevData) => ({
  //             ...prevData,
  //             PlayerId: newPlayerId,
  //           }));
  //         } catch (error) {
  //           console.error("Error in sendToAdminForEvaluation:", error);
  //           throw error; // Re-throw the error to be caught in the handleSubmit function
  //         }
  //         console.log("Inserted PlayerId: ", newPlayerId);
  //         //admin
  //       }
  //       console.log(formData);
  //       let EarlynewVariationNameId = newVariationNameId;

  //       if (thisIsANewVariationName) {
  //         const preInsert = { cardName: newVariationName.label };
  //         console.log("new variationName", preInsert);
  //         const insertIntocardvariation = await axios.post(
  //           `${process.env.REACT_APP_API_BASE}/api/add/NewVariationName`,
  //           preInsert
  //         );
  //         EarlynewVariationNameId = insertIntocardvariation.data;
  //         const preInsertAdmin = {
  //           tableName: "cardvariation",
  //           id: EarlynewVariationNameId,
  //           UserId: userId,
  //         };
  //         const responseSendToAdmin = await axios.post(
  //           `${process.env.REACT_APP_API_BASE}/api/admin/InsertIntoApprobation`,
  //           preInsertAdmin
  //         );

  //         setNewVariationNameId(EarlynewVariationNameId);
  //         //doit faire la query et mettre l'option base pour la variation,
  //         //Mettre base par defaut et
  //         setThisIsANewVariationName(false);
  //       }
  //       if (thisIsANewVariation) {
  //         const preInstert = {
  //           IdCardVariation: EarlynewVariationNameId,
  //           variationName: newVariation.label,
  //           IdSet: "tbd",
  //           isAuto: formData.IsAuto,
  //           isPatch: formData.IsPatch,
  //           numbered: formData.Numbered,
  //           isRookie: formData.IsRookie,
  //           isJersey: formData.IsJersey,
  //         };
  //         console.log("new variation", preInstert);
  //         const insertIntovariation = await axios.post(
  //           `${process.env.REACT_APP_API_BASE}/api/add/Variation`,
  //           preInstert
  //         );
  //         const newVariationId = insertIntovariation.data;
  //         const preInsertAdmin = {
  //           tableName: "variation",
  //           id: newVariationId,
  //           UserId: userId,
  //         };
  //         const responseSendToAdmin = await axios.post(
  //           `${process.env.REACT_APP_API_BASE}/api/admin/InsertIntoApprobation`,
  //           preInsertAdmin
  //         );
  //         console.log("newVariaitionId admin", newVariationId);
  //         setFormData((prevData) => ({
  //           ...prevData,
  //           Variation: newVariationId,
  //         }));

  //         setThisIsANewVariation(false);
  //       }

  //       //doit faire la query et mettre l'option base pour la variation,
  //       //Mettre base par defaut et

  //       if (thisIsANewPlayer) {
  //         const readytoInsert = {
  //           PlayerId: newPlayerId,
  //           userId: AccesUserId,
  //           Type: formData.Type,
  //           cardName: formData.cardName,
  //           YearMade: formData.YearMade,
  //           IsRookie: formData.IsRookie,
  //           IsPatch: formData.IsPatch,
  //           IsAuto: formData.IsAuto,
  //           IsJersey: formData.IsJersey,
  //           IsTribute: formData.IsTribute,
  //           Variation: formData.Variation,
  //           Numbered: formData.Numbered,
  //           Sets: formData.Sets,
  //           SpecialAttribute: formData.SpecialAttribute,
  //           Image: formData.Image,
  //           ImageBack: formData.ImageBack,
  //           NumberBehind: formData.NumberBehind,
  //           Graded: formData.Graded,
  //           GradeCompany: formData.GradeCompany,
  //           Grade: formData.Grade,
  //           isPC: formData.isPC,
  //           isForSale: formData.isForSale,
  //           isForTrade: formData.isForTrade,
  //           isOnEbay: formData.isOnEbay,
  //           ConditionCard: formData.ConditionCard,
  //           EstimateValue: formData.EstimateValue,
  //           PaidPrice: formData.PaidPrice,
  //           Location: formData.Location,
  //         };
  //         console.log(
  //           "on est dans la section new player sur le bord de faire readytoinsert"
  //         );
  //         console.log(readytoInsert);
  //         const response = await axios.post(
  //           "https://projet-collect-v1-production.up.railway.app/api/add/cardOnly",
  //           readytoInsert
  //         );

  //         setSuccessMessage(
  //           "Card created successfully with newPlayer (cardOnly)"
  //         );
  //         newOrNotCardId = response.data.cardId;
  //         console.log(
  //           "newOrnotcardId avec newplayer responsedata:",
  //           newOrNotCardId
  //         );
  //         setThisIsANewPlayer(false);
  //         UpdateCardIdFromUserCardId(
  //           newOrNotCardId,
  //           location?.state?.card.id,
  //           location?.state?.card.CardId
  //         );
  //         // playerId =
  //       } else {
  //         console.log("on est pas dans not");
  //         console.log(formData);

  //         const validation = await doesItMatchAnExistingCard();
        
  //         const response = await axios.post(
  //           "https://projet-collect-v1-production.up.railway.app/api/add/cardOnly",
  //           {
  //             ...formData,
  //             userId: AccesUserId,
  //             // Include the userId in the request payload
  //           }
  //         );
  //         newOrNotCardId = response.data.cardId;
  //         console.log("newOrNotCardId : ", newOrNotCardId);
  //         console.log(
  //           "newOrnotcardId sans newplayer responsedata:",
  //           newOrNotCardId
  //         );
  //         //setSuccessMessage("Card created successfully (cardOnly)");
  //         toast.success(t("Card created successfully"));
  //         UpdateCardIdFromUserCardId(
  //           newOrNotCardId,
  //           location?.state?.card.id,
  //           location?.state?.card.CardId
  //         );
  //       }

  //       //call function update cardId where userId =adsa and userId = aasdad
  //     }

  //     const cardStatusUpdate = {
  //       cardIds: [formData.userCardId],  // Include cardId from the form
  //       isPcUpdate: formData.isPC,  // PC status update
  //       isForSaleUpdate: formData.isForSale,  // For sale status update
  //       isForTradeUpdate: formData.isForTrade,  // For trade status update
  //       isOnEbayUpdate: formData.isOnEbay,  // On eBay status update
  //       userId: userId,  // Include userId for validation
  //       liveCsrfToken: liveCsrfToken,  // Include CSRF token for security
  //     };
      
  //     console.log("card status update:", cardStatusUpdate);
      
  //     const updateResponse = await axios.post(
  //       "https://projet-collect-v1-production.up.railway.app/api/collection/update/status",
  //       cardStatusUpdate,  { withCredentials: true }
  //     );

  //     const cardForSaleForTradeUpdate = {
  //       userCardId: cardStatusUpdate.cardIds,  // Include userCardId from the previous step
  //       userId: userId,  // Include userId in the request body
  //       isForSaleUpdate: formData.isForSale,  // Update sale status
  //       isForTradeUpdate: formData.isForTrade,  // Update trade status
  //       Price: formData.SalePrice,  // Sale price
  //       ShippingTemplate: parseInt(formData.ShippingTemplate),  // Shipping template (parsed as integer)
  //       Shipping: formData.Shipping,  // Shipping details
  //       TradingTemplate: formData.TradingTemplate,  // Trading template
  //       tradeValue: formData.EstimateValue,  // Estimated trade value
  //       BestOffer: formData.BestOffer,  // Best offer option
  //       liveCsrfToken: liveCsrfToken,  // Include CSRF token for validation
  //     };

     
  //     const updateForSaleForTradeResponse = await axios.post(
  //       "https://projet-collect-v1-production.up.railway.app/api/collection/CreateEdit/ForSaleForTrade",
  //       cardForSaleForTradeUpdate,{ withCredentials: true }
  //     );
  //     toast.success(isAddingNewCard?t("Card created successfully"):t("Updated successfully"));
      
     
  //     if (selectedCollectionLive.ListId !== 0) {
  //       insertIntoCardsCardsList(selectedCollectionLive, formData.userCardId);
  //       toast.success(t("Card assigned to collection ") + selectedCollectionLive[1]);
    
  //     } else console.log("devrait pas Assign,listid 0");
  //   } catch (error) {
  //     setErrorMessage(error.message);
  //     toast.error(t("Error occurred while creating the card"))
  //     console.log("Error inserting card or new player");
  //     console.log(error.message);
  //   }
  //   setIsLoading(false);
  // };

  const sendToAdminForApproval = async (tableName, id) => {
    try {
        const preInsertAdmin = { tableName, id, UserId: userId };

        const response = await axios.post(
            `${process.env.REACT_APP_API_BASE}/api/admin/InsertIntoApprobation`,
            preInsertAdmin
        );

        toast.success(t("Submission sent for admin approval"));
    } catch (error) {
        if (error.response?.status === 409) {
            toast.warning(t("This entry is already awaiting approval."));
        } else {
            toast.error(t("Error sending for approval"));
        }
        console.error("❌ Error submitting for admin approval:", error);
    }
};

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("Form submission started");
    const catalogType = isPokemon ? "Pokemon" : "Hockey";
const userCardId = location?.state?.card?.id ?? formData.userCardId;
const oldCardId  = location?.state?.card?.CardId ?? formData.cardId;
let targetCardId = formData?.cardId || formData?.CardId;

    setIsLoading(true);
 let newVariationId = formData?.Variation ||0;
    const newErrors = validateForm();
    console.log("Validation errors:", newErrors);

    if (Object.keys(newErrors).length > 0) {
        console.log("Form has validation errors. Preventing submission.");
        setErrors(newErrors);
        toast.error(t("Please fill in all required fields"));
        setIsLoading(false);
        return;
    }

    const AccesUserId = userId;
    console.log("UserId:", AccesUserId);

   let cardIdMatch = 0; // default for Pokémon

cardIdMatch = await doesItMatchAnExistingCard(catalogType);

    let newOrNotCardId = formData?.cardId||formData?.CardId;
    console.log("Initial cardId from formData:", newOrNotCardId);
    console.log("FormData before processing:", formData);

    try {
        // ✅ Check if images have changed
        const isNewImage = formData.Image instanceof File;
        const isNewImageBack = formData.ImageBack instanceof File;

        // ✅ Create FormData to handle files
        const formDataToSend = new FormData();
        formDataToSend.append("userCardId", formData.userCardId);
        formDataToSend.append("userId", AccesUserId);
        formDataToSend.append("SpecialAttribute", formData.SpecialAttribute||'');
        formDataToSend.append("Graded", toIntBool(formData.Graded));
        formDataToSend.append("GradeCompany", formData.GradeCompany);
        formDataToSend.append("Grade", formData.Grade);
        formDataToSend.append("isPC", toIntBool(formData.isPC));
        formDataToSend.append("isForSale", toIntBool(formData.isForSale));
        formDataToSend.append("isForTrade", toIntBool(formData.isForTrade));
        formDataToSend.append("isOnEbay", toIntBool(formData.isOnEbay));
        formDataToSend.append("ConditionCard", formData.ConditionCard);
        formDataToSend.append("EstimateValue", formData.EstimateValue);
        formDataToSend.append("PaidPrice", formData.PaidPrice);
        formDataToSend.append("Location", formData.Location);
        formDataToSend.append("isNewImage", isNewImage);
        formDataToSend.append("isNewImageBack", isNewImageBack);

        // ✅ Append images only if they have changed
        if (isNewImage) {
            formDataToSend.append("Image", formData.Image);
        }
        if (isNewImageBack) {
            formDataToSend.append("ImageBack", formData.ImageBack);
        }

        console.log("Prepared userCardFormData:", formDataToSend);

        // ✅ Update an existing card
        if (location?.state?.card.CardId === cardIdMatch) {
            console.log("Editing card with the same ID as matched.");
            const response = await axios.put(
                `${process.env.REACT_APP_API_BASE}/api/update/userCard/sameCardId`,
                formDataToSend, // ✅ Send FormData instead of JSON
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                     withCredentials: true,
                }
            );
            console.log("Update response:", response.data);
            toast.success(t("Card updated successfully"));
        } 
        // ✅ If the card is new, insert it
        else if (cardIdMatch === 0 && !isPokemon) {
          let  newVariationNameIdLocal = newVariationNameId
          console.log("Creating a new card.");
            console.log("thisIsANewPlayer:", thisIsANewPlayer, "thisIsANewVariationName:", thisIsANewVariationName);

            if (thisIsANewPlayer) {
                console.log("Processing new player creation...");
                const sport = formData.Type;
                const tempoNewPlayer = { Type: sport, PlayerName: newPlayerName.label };
                console.log("New player data:", tempoNewPlayer);

                const responseInsertPlayerNotFound = await axios.post(
                    `${process.env.REACT_APP_API_BASE}/api/add/NewPlayer`,
                    tempoNewPlayer,
  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true, // ✅ correct for Axios
  }
                );
                console.log("New player ID response:", responseInsertPlayerNotFound.data);
                await sendToAdminForApproval("players", responseInsertPlayerNotFound.data);
                setFormData((prevData) => ({
                    ...prevData,
                    PlayerId: responseInsertPlayerNotFound.data,
                }));
              
            }

            if (thisIsANewVariationName) {
                console.log("Processing new variation name creation...");
                const preInsert = { cardName: newVariationName.label,InsertFamilyId: newVariationName.InsertFamilyId  };
                console.log("New variation name data:", preInsert);

                const insertIntocardvariation = await axios.post(
                    `${process.env.REACT_APP_API_BASE}/api/add/NewVariationName`,
                    preInsert
                ,
  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true, // ✅ correct for Axios
  });
                newVariationNameIdLocal = insertIntocardvariation.data
                console.log("New variation name response:", newVariationNameIdLocal);
                
                 await sendToAdminForApproval("cardvariation",newVariationNameIdLocal)
            }

            if (thisIsANewVariation) {
  const preInstert = {
    IdCardVariation: newVariationNameIdLocal,
    variationName: newVariation.label,
    IdSet: formData.Sets || 0,
    isAuto: toIntBool(formData.IsAuto),
    isPatch: toIntBool(formData.IsPatch),
    numbered: formData.Numbered === "" ? 0 : formData.Numbered,
    isRookie: toIntBool(formData.IsRookie),
    isJersey: toIntBool(formData.IsJersey),
  };

  const insertIntovariation = await axios.post(
    '/api/add/Variation',
    preInstert,
  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true, // ✅ correct for Axios
  }
  );

  newVariationId = insertIntovariation.data;
  await sendToAdminForApproval("variation", newVariationId);
  setThisIsANewVariation(false);
}

            console.log("Inserting new card...");
            
            formDataToSend.append("PlayerId", formData.PlayerId);
            formDataToSend.append("Type", formData.Type);
            formDataToSend.append("CardName", formData.cardName);
            formDataToSend.append("YearMade", formData.YearMade);
            formDataToSend.append("IsRookie", toIntBool(formData.IsRookie));
            formDataToSend.append("IsPatch", toIntBool(formData.IsPatch));
            formDataToSend.append("IsAuto", toIntBool(formData.IsAuto));
            formDataToSend.append("IsJersey", toIntBool(formData.IsJersey));
           
            formDataToSend.append("Variation", newVariationId);
            formDataToSend.append("Numbered", formData.Numbered);
            formDataToSend.append("Sets", formData.Sets);
          
            const debugFormData = {};
            for (let [key, value] of formDataToSend.entries()) {
              debugFormData[key] = value;
            }
            console.log("FormData content:", debugFormData);

            console.log("Inserting new card...formDataToSend",formDataToSend);
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE}/api/add/cardOnly`,
                formDataToSend, // ✅ Send FormData instead of JSON
             
  {
    headers: {
      "Content-Type": "multipart/form-data",
        "x-csrf-token": liveCsrfToken,
    },
    withCredentials: true, // ✅ correct for Axios
  }
            );

            console.log("New card creation response:", response.data);
            toast.success(t("Card created successfully"));
        }
         else if (cardIdMatch === formData?.cardId)
        {
         if (userCardId == null || oldCardId == null) {
  console.error('Missing IDs', { cardIdMatch, userCardId, oldCardId });
  toast.error(t('Missing identifiers to update card link'));
} else {
  UpdateCardIdFromUserCardId(cardIdMatch, userCardId, oldCardId);
}
        }
        else {
          console.log("Updating card to match existing card ID.");
       if (userCardId == null || oldCardId == null) {
  console.error('Missing IDs', { cardIdMatch, userCardId, oldCardId });
  toast.error(t('Missing identifiers to update card link'));
} else {
  UpdateCardIdFromUserCardId(cardIdMatch, userCardId, oldCardId);
}
        }

        
        try{
      

      const cardForSaleForTradeUpdate = {
        userCardId:location?.state?.card.id ,  // Include userCardId from the previous step
        userId: userId,  // Include userId in the request body
        isForSaleUpdate: toIntBool(formData.isForSale),  // Update sale status
        isForTradeUpdate: toIntBool(formData.isForTrade),  // Update trade status
        isPcUpdate:toIntBool(formData.isPC),
        isOnEbayUpdate:toIntBool(formData.isOnEbay),
        Price: formData.SalePrice,  // Sale price
        ShippingTemplate: parseInt(formData.ShippingTemplate),  // Shipping template (parsed as integer)
        Shipping: formData.Shipping,  // Shipping details
        TradingTemplate: formData.TradingTemplate,  // Trading template
        tradeValue: formData.EstimateValue,  // Estimated trade value
        BestOffer: formData.BestOffer||false,  // Best offer option
        liveCsrfToken: liveCsrfToken,  // Include CSRF token for validation
      };

     
      try {
        const updateResponse = await axios.post(
            `${process.env.REACT_APP_API_BASE}/api/collection/update/AllStatusOneShot`,
            cardForSaleForTradeUpdate, { withCredentials: true }
        );
        console.log("✅ Sale/Trade status updated:", updateResponse.data);
    } catch (error) {
        console.error("❌ Error updating Sale/Trade status:", error);
    }

      
     
      if(parseInt(selectedCollectionLive?.value) !== 0) {


        insertIntoCardsCardsList(selectedCollectionLive.value, formData.userCardId);
        console.log('je fais un test :',selectedCollectionLive.value,'formData.userCardId',formData.userCardId,selectedCollectionLive,'selectedCollectionLive')

        
        toast.success(t("Card assigned to collection ") + selectedCollectionLive.label);
    
      } else console.log("devrait pas Assign,listid 0");
    } catch (error) {
      setErrorMessage(error.message);
      toast.error(t("Error occurred while creating the card"))
      console.log("Error inserting card or new player");
      console.log(error.message);
    }
    setIsLoading(false);
    } catch (error) {
        console.error("❌ Error during submission:", error);
        toast.error(t("Error submitting the card. Please try again."));
    } finally {
        setIsLoading(false);
    }
};


const UpdateCardIdFromUserCardId = async (newCardId, userCardIdAffected, previousCardId) => {

  console.log('newCardId, userCardIdAffected, previousCardId',newCardId, userCardIdAffected, previousCardId)
  try {
      if (!newCardId || !userCardIdAffected) {
          console.error("Invalid card IDs provided for update.");
          return;
      }
      console.log('Updating CardId:', { newCardId, userCardIdAffected, previousCardId });

      const response = await axios.put(`${process.env.REACT_APP_API_BASE}/api/card/update/AssignNewCardId`, {
          newCardId, userCardIdAffected,previousCardId, userId
      }, {
          headers: {
              "Content-Type": "application/json",
              "x-csrf-token": liveCsrfToken,
          },
          withCredentials: true,
      });

      console.log("✅ CardID updated successfully:", response.data);
      toast.success(t("Card updated successfully"));
      return response.data;
  } catch (error) {
      console.error("❌ Error updating CardID:", error);
  }
};




  const createOptionPlayer = (label) => ({
    value: 0,
    label,
    rookieYear: 0,
  });

  const handleCreate = async (inputValue) => {
    setIsLoading(true);

    try {
      // Simulate an asynchronous operation with await
      const newOption = createOptionPlayer(inputValue);
      console.log("newoption", newOption);

      // Simulate an asynchronous operation with setTimeout
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setIsLoading(false);
      setOptions((prev) => [...prev, newOption]);
      setFormData((prevData) => ({
        ...prevData,
        playerId: newOption.value,
      }));
      setNewPlayerName(newOption);
      setThisIsANewPlayer(true);
    } catch (error) {
      console.error("Error creating option:", error);
      setIsLoading(false);
    }
  };

  const isDuplicate = async (inputValue) => {
    const cleaned = normalizeInput(inputValue);
  
    const existsLocally =
      variation.some((v) => v.label.toLowerCase() === cleaned.toLowerCase()) ||
      filteredVariation.some((v) => v.label.toLowerCase() === cleaned.toLowerCase());
  
    if (existsLocally) return true;
  
    try {
      // Call directly to `/variation-exists` (not /api/variation-exists)
      const res = await fetch(`/variation-exists?label=${encodeURIComponent(cleaned)}`, {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
      const data = await res.json();
      return data.exists;
    } catch (error) {
      console.error('Error checking variation from API:', error);
      return false;
    }
  };
  
  const isCardVariationDuplicate = async (inputValue) => {
    const cleaned = normalizeInput(inputValue);
  
    // Check local list first (case-insensitive)
    const existsLocally = filteredVariation.some(
      (v) => v.label.toLowerCase() === cleaned.toLowerCase()
    );
  
    if (existsLocally) return true;
  
    try {
      const res = await fetch(`/cardvariation-exists?label=${encodeURIComponent(cleaned)}`, {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
      if (!res.ok) throw new Error('Server error');
      
      const data = await res.json();
      return data.exists;
    } catch (error) {
      console.error('Error checking cardvariation from API:', error);
      return false; // fallback: allow it through if API fails
    }
  };
  

  const createVariationName = (label) => ({
    value: 0,
    label: label,
    name: "tobedetermine",
    InsertFamilyId:setsCurrentlySelected.InsertFamilyId,
  });

  const handleCreateVariationName = async (inputValue) => {
    
      const cleanedInput = normalizeInput(inputValue);
      if (!cleanedInput || cleanedInput.length < 2) {
        toast.error("Please enter a valid variation name.");
        return;
      }
      if (await isDuplicate(cleanedInput)) {
        toast.error("This variation already exists.");
        return;
      }

    setIsLoading(true);
    setNewVariation("");
    setVariationLocked(false);
    try {
      // Simulate an asynchronous operation with await
      ResetAttributBecauseVariationCreate();
      const newVariationName = createVariationName(cleanedInput);
      console.log("newVariationName", newVariationName);

      //handleCreateVariation("Base");
      // Simulate an asynchronous operation with setTimeout
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setIsLoading(false);
      setVariation((prev) => [...prev, newVariationName]);

      setNewVariationName(newVariationName);
      setNewVariation({ value: "Base", label: "Base" })
      setThisIsANewVariationName(true);
      setThisIsANewVariation(true)
      

    } catch (error) {
      console.error("Error creating option:", error);
      setIsLoading(false);
    }
  };

  const createVariation = (label) => ({
    value: 0,
    label: label,
    name: "tobedetermine",
  });

  const handleCreateVariation = async (inputValue) => {

    
        const cleanedInput = normalizeInput(inputValue);
        if (!cleanedInput || cleanedInput.length < 2) {
          toast.error("Please enter a valid variation name.");
          return;
        }
      
        if (await isCardVariationDuplicate(cleanedInput)) {
          toast.error("This variation already exists.");
          return;
        }
    setIsLoading(true);
    try {
      // Simulate an asynchronous operation with await
      const newVariation = createVariation(inputValue);
      console.log("newVariation", newVariation);
      ResetAttributBecauseVariationCreate();
      // Simulate an asynchronous operation with setTimeout
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsLoading(false);
      setCardVariation((prev) => [...prev, newVariation]);
      setNewVariation(newVariation);
      setThisIsANewVariation(true);
      setVariationLocked(false)
    } catch (error) {
      console.error("Error creating option:", error);
      setIsLoading(false);
    }
  };

  const ResetAttributBecauseVariationCreate = async () => {
    setFormData((prevData) => ({
      ...prevData,
      IsRookie: 1,
      IsAuto: 0,
      IsJersey: 0,
      IsPatch: 0,
      Numbered: 0,
    }));
  };

  const handleTypeClick = (type) => {
    setSelectedType(type);
    setFormData((prevData) => ({
      ...prevData,
      Type: type,
    }));
  };

  // <form onSubmit={handleTest} className='formInsertCard'>
  const handlePriceAndShippingChange = (
    newPrice,
    shippingTemplateId,
    shipping,
    BestOffer
  ) => {
    setFormData({
      ...formData,
      SalePrice: newPrice,
      ShippingTemplate: shippingTemplateId,
      Shipping: shipping,
      BestOffer: BestOffer,
    });

    console.log("743 ", newPrice, "id shipp ", shippingTemplateId);
  };

  const ToggleButtonGradedRaw = ({ label, active, onChange }) => {
    return (
      <button
        type="button"
        className={`toggle-button ${active ? "active" : ""}`}
        onClick={onChange}
      >
        {label}
      </button>
    );
  };
  const ToggleButton = ({ label, name, value, onChange, disabled,tabindex }) => {
    const handleClick = () => {
      if (!disabled) {
        onChange(name, !value);
      }
    };

    return (
      <button
        type="button"
        className={`btn-toggle ${value ? "is-active" : "is-inactive"} ${
          disabled ? "disabled" : ""
        }`}
        onClick={handleClick}
        disabled={disabled} // This will apply the native HTML disabled attribute
        aria-pressed={value}
        tabIndex={tabindex}
      >
        {t(label)}
      </button>
    );
  };

 const GradingCompanyAndGradeSelection = ({ formData, setFormData }) => {
    const gradingCompanies = ["PSA", "BGS", "SGC", "MINT"];
    const additionalCompanies = [
      "ACA",
      "AGS",
      "ASA",
      "BCCG",
      "CGC",
      "CSG",
      "GAI",
      "HGA",
      "KSA",
      "MBG",
      "MINT",
      "OverTime",
      "PWI",
      "SFTB",
      "Other",
    ]; // Additional grading companies for the dropdown

    const gradeButtons = [10, 9.5, 9, 8.5, 8];
    const lowerGrades = [
      7.5, 7, 6.5, 6, 5.5, 5, 4.5, 4, 3.5, 3, 2.5, 2, 1.5, 1,
    ];

    const handleCompanySelect = (company) => {
      setFormData({
        ...formData,
        GradeCompany: company,
      });
    };

    const handleGradeButtonClick = (grade) => {
      setFormData({
        ...formData,
        Grade: grade,
      });
    };

    const handleGradeDropdownChange = (e) => {
      setFormData({
        ...formData,
        Grade: e.target.value,
      });
    };

    return (
      <div>
        <div>
          <label>{t("Grading company")}</label>
          <div className="flex-h gap">
            {gradingCompanies.map((company) => (
              <button
                key={company}
                
              className={`btn-toggle ${formData.GradeCompany === company ? "is-active" : "is-inactive"}`}
                onClick={() => handleCompanySelect(company)}
              >
                {company}
              </button>
            ))}
            <select
            styles={searchSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
             // className="custom-dropdown"
              value={
                gradingCompanies.includes(formData.GradeCompany)
                  ? ""
                  : formData.GradeCompany
              }
              onChange={(e) => handleCompanySelect(e.target.value)}
            >
              <option value="">{t("Other")}</option>
              {additionalCompanies.map((company) => (
                <option key={company} value={company}>
                  {company}
                </option>
              ))}
            </select>
          </div>
        </div>
        <label>{t("Grade")}</label>
        <div className="flex-h gap">
          {gradeButtons.map((grade) => (
            <button
              key={grade}
              className={`btn-toggle ${formData.Grade === grade ? "is-active" : "is-inactive"}`}
           
              onClick={() => handleGradeButtonClick(grade)}
            >
              {grade}
            </button>
          ))}

          <select
                    styles={searchSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
            value={formData.Grade < 8 ? formData.Grade : ""}
            onChange={handleGradeDropdownChange}
          >
            <option value="">{t("Select Grade")}</option>
            {lowerGrades.map((grade) => (
              <option key={grade} value={grade}>
                {grade
                }
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  };


function generateEbaySearchUrl(formData, newVariation) {
  const queryParts = [];

  const lowerCardName = formData?.cardName?.toLowerCase() || "";
  const lowerVariation = newVariation?.toLowerCase() || "";

  // Set + card number + player
  if (formData?.SetName) queryParts.push(formData.SetName);
  if (formData?.NumberBehind) queryParts.push(`#${formData.NumberBehind}`);
  if (formData?.Name) queryParts.push(formData.Name);

  // Card name (skip if contains "base")
  if (formData?.cardName && !/base/i.test(formData.cardName)) {
    queryParts.push(formData.cardName.trim());
  }

  // Variation (skip if contains "base")
  if (newVariation && !/base/i.test(newVariation.trim())) {
    queryParts.push(newVariation.trim());
  }

  // Graded
  const isGraded =
    formData?.Graded === true ||
    formData?.Graded === "true" ||
    formData?.Graded === 1;

  if (isGraded && formData?.GradeCompany && formData?.Grade > 0) {
    queryParts.push(`${formData.GradeCompany} ${formData.Grade}`);
  }

  // Keywords (only if not already present)
  if (formData?.IsAuto && !lowerCardName.includes("auto") && !lowerVariation.includes("auto")) {
    queryParts.push("auto");
  }

  if (formData?.IsPatch && !lowerCardName.includes("patch") && !lowerVariation.includes("patch")) {
    queryParts.push("patch");
  }

  if (formData?.IsJersey && !lowerCardName.includes("jersey") && !lowerVariation.includes("jersey")) {
    queryParts.push("jersey");
  }

  const query = queryParts.join(" ");
  const userLocale = navigator.language || navigator.userLanguage;
  const ebayBaseUrl = userLocale.includes("CA")
    ? "https://www.ebay.ca/sch/i.html"
    : "https://www.ebay.com/sch/i.html";

  return `${ebayBaseUrl}?_nkw=${encodeURIComponent(query)}&LH_Sold=1`;
}

const MAX_CHIPS = 8;

function ChipsFromLabel({ label }) {
  const parts = label.split(" - ").filter((p) => !/^\d{4}-\d{2}$/.test(p));
  if (parts.length < 4) return null;

  const chips = parts.slice(3); // everything after title parts
  const shown = chips.slice(0, MAX_CHIPS);
  const overflow = Math.max(0, chips.length - shown.length);

  return (
    <div className="qs__chips">
      {shown.map((txt, i) => (
        <span key={i} className="qs__chip">{txt}</span>
      ))}
      {overflow > 0 && <span className="qs__chip qs__chip--more">+{overflow}</span>}
    </div>
  );
}

const formatOptionLabel = (opt) => {
  const full = opt.label || "";
  const parts = full.split(" - ").filter((p) => !/^\d{4}-\d{2}$/.test(p));
  const title = parts.slice(0, 4).join(" - ");

  return (
    <div className="qs__item">
      {opt.Image ? (
        <div className="qs__thumb">
          <img
            src={opt.Image}
            alt=""
            loading="lazy"
          />
        </div>
      ) : (
        <div className="qs__thumb qs__thumb--placeholder" aria-hidden="true" />
      )}

      <div className="qs__text">
        <div className="qs__title" title={title}>{title}</div>
        <ChipsFromLabel label={full} />
      </div>
    </div>
  );
};

  // const ShowCompleteCard = ({ formData }) => {
  //   return (
  //     <div className="cardcontentForm">
  //       <div className="card">
  //         <div className="img">
  //           <img
  //             className="card-image"
  //             src={previewImage}
  //             alt="Card Preview"
  //           />
  //           <div className="filter"></div>
  //           <div className="card-isWhat">
  //             {/* Conditional Patches */}
  //             {formData.IsRookie === 1 && (
  //               <div className="patch spe">
  //                 <p className="strong">RC</p>
  //               </div>
  //             )}
  //             {formData.IsPatch === 1 && (
  //               <div className="patch">
  //                 <p>Patch</p>
  //               </div>
  //             )}
  //             {formData.IsJersey === 1 && (
  //               <div className="patch">
  //                 <p>Jersey</p>
  //               </div>
  //             )}
  //             {formData.IsAuto === 1 && (
  //               <div className="patch">
  //                 <p>Auto</p>
  //               </div>
  //             )}
           
  //                 {formData.Numbered && formData.Numbered !== "0" && (
  //               <div className="patch spe">
  //               <p>/{formData.Numbered}</p>
  //             </div>
  //             )}
  //           </div>
  //         </div>
  
  //         <div className="txt">
  //           <div className="justify">
  //             <h4 className="card-name">{formData.Name}</h4>
  //             <p className="card-IDcard ">#{formData.NumberBehind}</p>
  //           </div>
  //           <p className="card-set">{formData.SetName}</p>
  //           <div className="flex-h">
  //             <p className="card-variation">
  //               {`${formData.cardName} - ${newVariation.label}`}
  //             </p>
  //             {/* {formData.Numbered && formData.Numbered !== "0" ? (
  //               <p className="card-numbered"> / {formData.Numbered} </p>
  //             ) : null} */}
  //           </div>
  
  //           <div className="ShowCompleteCard">
  //             {/* Add 'For Sale' patch if applicable */}
  //             {formData.isForSale === true && (
  //               <div className="patch">
  //                 <p>{t("ForSale")}</p>
  //               </div>
  //             )}
  //             {formData.isPC === true && (
  //               <div className="patch">
  //                 <p>PC</p>
  //               </div>
  //             )}
  //             {formData.isForTrade === true && (
  //               <div className="patch">
  //                 <p>{t("ForTrade")}</p>
  //               </div>
  //             )}
  //             {formData.isOnEbay === true && (
  //               <div className="patch">
  //                 <p>{t("OnEbay")}</p>
  //               </div>
  //             )}
  //           </div>
  
  //           {/* Display Price or TV if available */}
  //           <div className="card-value">
  //             {formData.EstimateValue ? (
  //               <h4>
  //                 ({t("Estimate/TV")}) {formData.EstimateValue}$
  //               </h4>
  //             ) : null}
  
  //             {formData.SalePrice ? (
  //               <h4>
  //                 ({t("Price")}) {formData.SalePrice}$
  //               </h4>
  //             ) : null}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };
function generateEbaySearchUrl(formData, newVariation) {
  const queryParts = [];

  const lowerCardName = formData?.cardName?.toLowerCase() || "";
  const lowerVariation = newVariation?.toLowerCase() || "";

  // Set + card number + player
  if (formData?.SetName) queryParts.push(formData.SetName);
  if (formData?.NumberBehind) queryParts.push(`#${formData.NumberBehind}`);
  if (formData?.Name) queryParts.push(formData.Name);

  // Card name (skip if contains "base")
  if (formData?.cardName && !/base/i.test(formData.cardName)) {
    queryParts.push(formData.cardName.trim());
  }

  // Variation (skip if contains "base")
  if (newVariation && !/base/i.test(newVariation.trim())) {
    queryParts.push(newVariation.trim());
  }

  // Graded
  const isGraded =
    formData?.Graded === true ||
    formData?.Graded === "true" ||
    formData?.Graded === 1;

  if (isGraded && formData?.GradeCompany && formData?.Grade > 0) {
    queryParts.push(`${formData.GradeCompany} ${formData.Grade}`);
  }

  // Keywords (only if not already present)
  if (formData?.IsAuto && !lowerCardName.includes("auto") && !lowerVariation.includes("auto")) {
    queryParts.push("auto");
  }

  if (formData?.IsPatch && !lowerCardName.includes("patch") && !lowerVariation.includes("patch")) {
    queryParts.push("patch");
  }

  if (formData?.IsJersey && !lowerCardName.includes("jersey") && !lowerVariation.includes("jersey")) {
    queryParts.push("jersey");
  }

  const query = queryParts.join(" ");
  const userLocale = navigator.language || navigator.userLanguage;
  const ebayBaseUrl = userLocale.includes("CA")
    ? "https://www.ebay.ca/sch/i.html"
    : "https://www.ebay.com/sch/i.html";

  return `${ebayBaseUrl}?_nkw=${encodeURIComponent(query)}&LH_Sold=1`;
}


  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#222",
      border: "1px solid #444",
      color: "white",
      borderRadius: "8px",
      padding: "6px",
      "&:hover": { borderColor: "#0066FFED" },
      minWidth:'23vw',
      minHeight: '55px'
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#181818",
      borderRadius: "6px",
      padding: "5px",
      border: "1px solid #444",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "#F5F5F5",
      backgroundColor: state.isSelected ? "#0066FFED" : "#222",
      padding: "5px",
      borderRadius: "6px",
      "&:hover": { backgroundColor: "#0066FFED", color: "white" },
    }),
  };

  
  const stylingSelect={
    control: (provided) => ({
      ...provided,
      backgroundColor: "#222", // Set the background color to black
      color: "white", // Set the text color to white
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#222", // Set the background color of the dropdown menu to black
      color: "white", // Set the text color of the dropdown menu to white
    }),
    option: (provided, state) => ({
      ...provided,
      color: "white", // Set the text color for selected and non-selected options
      backgroundColor: state.isSelected ? "#0066FFED" : null, // Set the background color for selected options
      "&:hover": {
        backgroundColor: "#0066FFED", // Set the background color for hover effect
        color: "white", // Set the text color for hover effect
      },
    }),
  }
  //*##############################################################################################################################
    if (loading) return null;
  return (
    <>
       <SeoHelmet type="createCard" />
     
     
        <form className="formBackground create-card-form">
          {/* Left Section */}
          <div className="left-section">
                 <div className="panel">
              <p className="panel-title">{t('Basic Details')}</p>
            <div className="form-group">
            
            <ul className="nav nav-tabs seg-tabs" role="tablist" aria-label="Card type" style={{ marginTop: '1em' }}>
  <li className="nav-item" role="presentation">
    <button
      type="button"
      name="Type"
      role="tab"
      aria-selected={selectedType === "Hockey"}
      className={`nav-link ${selectedType === "Hockey" ? "active" : ""}`}
      onClick={() => handleTypeClick("Hockey")}
    >
      <FontAwesomeIcon icon={faHockeyPuck} /> Hockey
    </button>
  </li>

  <li className="nav-item" role="presentation">
    <button
      type="button"
      name="Type"
      role="tab"
      aria-selected={selectedType === "Pokemon"}
      className={`nav-link ${selectedType === "Pokemon" ? "active" : ""}`}
      onClick={() => handleTypeClick("Pokemon")}
      
    >
      Pokémon
    </button>
  </li>
</ul>

            </div>
     <div className="form-group">
            <label htmlFor="QuickSearch">QuickSearch: *</label>
<div className="select-wrapper search">
            {/* <Select
            classNamePrefix="myselect"
              className="search-select"
              styles={searchSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
              placeholder={t("Search for a DeepSearch")}
              isClearable
              onInputChange={(inputValue) => handleInputChange2(inputValue)}
              options={currentSuggestions} // Provide suggestions directly
              onChange={handleSearch2}
              //menuIsOpen={true}
               menuIsOpen={currentSuggestions.length > 0}
              //menuIsOpen={true}
              value={currentSuggestions}
              onMenuClose={() => {
                console.log("Select menu has been closed");
                // Add any logic you want to execute when the menu closes
                setCurrentSuggestions([]);
                handleInputChange2(inputValue, false);
              }}
              inputValue={inputValue}
              filterOption={() => true}
            
              formatOptionLabel={(currentSuggestion) => {
                // Extract label without patches
                const fullLabel = currentSuggestion.label||"";
                const parts = fullLabel.split(" - ").filter((part) => !/^\d{4}-\d{2}$/.test(part));
                const cleanLabel = parts.slice(0, 4).join(" - "); // Keep first 4 parts as main title
              
                return (
                  <div className="suggestion-item">
                    {currentSuggestion.Image ? (
                      <img src={`https://corsproxy.io/?${encodeURIComponent(currentSuggestion.Image)}`} alt="currentSuggestion-image"
                      />
                    ) : null}
                    <div className="text-content">
                      <span className="card-title">{cleanLabel}</span>
                      <div className="card-details">{ApplyPatch(fullLabel)}</div>
                    </div>
                  
                  </div>
                );
                
              }}
              tabIndex={1} // Ensures correct order in tab navigation
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  // If pressing enter, select the first option
                  if (currentSuggestions.length > 0) {
                    handleSearch2(currentSuggestions[0]);
                  }
                }
              }}

            /> */}
<Select
  classNamePrefix="qs"
  className="search-select"
  styles={searchSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
  placeholder={t("Search for a DeepSearch")}
  // isClearable
  value={null}                              // ← important
  inputValue={inputValue}
  onInputChange={(v, meta) => {
    // ignore clears caused by menu-close etc.
    if (meta.action === "input-change") handleInputChange2(v);
    if (meta.action === "menu-close") return;
  }}
  options={currentSuggestions}
  formatOptionLabel={formatOptionLabel}
  // menuIsOpen={inputValue.length >= 2 && currentSuggestions.length > 0}
  openMenuOnFocus={true}
  openMenuOnClick={true}
  onFocus={() => setQsFocused(true)}
   onBlur={() => setQsFocused(true)}
  //onBlur={() => setQsFocused(false)}
  noOptionsMessage={() =>
    inputValue.length < 2 ? t("Type at least 4 letters") : t("No results")
  }
  filterOption={() => true} // suggestions are pre-filtered upstream
  onChange={(opt) => {
    if (opt) {handleSearch2(opt)
      setQsFocused(false);
    };
  }}
  onKeyDown={(e) => {
    if (e.key === "Enter" && currentSuggestions.length > 0) {
      handleSearch2(currentSuggestions[0]);
    }
  }}
  // Inline clear button that resets input as well
  components={{
    ClearIndicator: (props) => (
      <div
        {...props.innerProps}
        onMouseDown={(e) => {
          e.preventDefault();
          setInputValue("");
          setCurrentSuggestions([]);
        }}
        className="qs__clear"
        aria-label={t("Clear")}
        title={t("Clear")}
      >
        ×
      </div>
    ),
  }}
/>

  {inputValue &&  (
    <button className="clear-btn"  onClick={() => {
      setInputValue("");
      setCurrentSuggestions([]);
    }}>❌</button>
  )}
</div>
</div>
            <div className="form-group">

              {!isPokemon ? (<>
              <label htmlFor="PlayerId">{t("Player")}:</label>
              {errors.PlayerId && <p className="error-message">{errors.PlayerId}</p>}
              <div style={{ width: "100%" }}>
              <div className="lockGroup">
                  <Select
                  ref={selectRefs.player}
                    key={selectKey}
                    placeholder={t("Search for a Player")}
                    //isClearable
                    isDisabled={testisLoading}
                    isLoading={testisLoading}
                    onChange={handleChange}
                    //menuIsOpen={true}
                    styles={formSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
                    //onCreateOption={handleCreate}
                    //onInputChange={handleInputChangeQuicker}
                    onInputChange={(input, { action }) => {
                      if (action === "input-change") {
                        handlePlayerInputChange(input,false);
                      } else if (action === "menu-close") {
                        markUserNav();
                        // Reset typed value if needed (optional)
                      }
                    }}
                    options={options}
                    value={newPlayerName}
                    className="form-control"
                   
                    filterOption={createFilter({ ignoreAccents: false })}
                    tabIndex={2}
  onKeyDown={(e) => {
    if (e.key === "Enter" && options.length > 0) {
      handleChange(options[0]);
    }
  }}
   onFocus={markUserNav}
  onMenuOpen={markUserNav}
  onMouseDown={markUserNav}
                  />
                  {/*()=>toggleFieldLock('PlayerId')}>*/}
                  {/* <button onClick={toggleFieldLock('PlayerId')}>
                    { isFieldsLocked && 'PlayerId' in lockedFields ? "Unlock PlayerId" : "Lock PlayerId"}  
                    </button> */}
 
                </div>
                {rookieYearForThisPlayer !== 0 && (
                  <label htmlFor="Labeltest" className="mt-2">
                    {t("Rookie Year")}: {rookieYearForThisPlayer}
                  </label>
                )}
                <div style={{ width: "100%" }}>
                  <label htmlFor="Uniform">
                    {t("Uniform")} *(Impact the filter - Team)
                  </label>
                   <Select
                    options={uniformListForThisPlayer}
                    onChange={handleChangeUniform}
                    placeholder={t("Search for a Uniform")}
                    filterOption={createFilter({ ignoreAccents: false })}
                    className="form-control"
                    styles={formSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
                    value={{
                      label: uniformCurrentlySelected?.label,
                      value: uniformCurrentlySelected?.value,
                    }}
                    disabled={
                      uniformListForThisPlayer === "" ||
                      uniformCurrentlySelected === "" ||
                      newPlayerName === ""
                    }
                    tabIndex={3}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && uniformListForThisPlayer.length > 0) {
                        handleChangeUniform(uniformListForThisPlayer[0]);
                      }
                    }}
                     onFocus={markUserNav}
  onMenuOpen={markUserNav}
  onMouseDown={markUserNav}
                  />
                </div>
  
                <div style={{ width: "100%" }}>

                  <div className="form-group">

                   <label htmlFor="Sets">Set: *  2019-20 Upper Deck The Cup</label>
                    {errors.Sets && <p className="error-message">{errors.Sets}</p>}
                   <div className="lockGroup">
                    <Select
  ref={selectRefs.set}         
  options={filteredSets}
  onChange={handleChangeSet}
  placeholder={t("Search for a Set")}
  filterOption={createFilter({ ignoreAccents: false })}
  className="form-control"
  styles={formSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
  value={setsCurrentlySelected}
 // menuIsOpen={openSelect === "set" || (filteredSets.length > 0 && setSearchTerm.length >= 3)}
  //inputValue={setsCurrentlySelected.label}
  
  onInputChange={(input, { action }) => {
    if (action === "input-change") {
      setSetSearchTerm(input);
      handleSetInputChange(input);
    }
  }}

  tabIndex={4}
  onKeyDown={(e) => {
    if (e.key === "Enter" && filteredSets.length > 0) {
      handleChangeSet(filteredSets[0]);
    }
  }} // Adding onInputChange for filtering sets

   onFocus={markUserNav}
  onMenuOpen={markUserNav}
  onMouseDown={markUserNav}
/>
                    </div>
                  </div>
                </div>
              </div>
  
              <div className="form-group">
                <label>e.g : Young Guns</label>
                {errors.cardName && <p className="error-message">{errors.cardName}</p>}
                 <div className="lockGroup">
                
                   
                  <CreatableSelect
                    placeholder={t("Select the card Name")}
                    
                    ref={selectRefs.variationName} 
                    isDisabled={testisLoading}
                    isLoading={testisLoading}
                    onChange={handleChangeVariationName}
                    onCreateOption={handleCreateVariationName}
                    options={variation}
                    //menuIsOpen={openSelect==="variationName"&&variation.length > 0}
                    value={newVariationName}
                    className="form-control"
                    styles={formSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
                    filterOption={createFilter({ ignoreAccents: false })}
                    
                    onInputChange={(input, { action }) => {
                      if (action === "input-change") {
                        handleCardInputChange(input);
                      }
                    }}
                    tabIndex={5}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && variation.length > 0) {
                        handleCardInputChange(variation[0]);
                      }
                    }}

                     onFocus={markUserNav}
  onMenuOpen={markUserNav}
  onMouseDown={markUserNav}
                  />
              
                </div>
              </div>
  
              <label>e.g : HighGloss - ClearCut</label>
              {errors.Variation && <p className="error-message">{errors.Variation}</p>}
            <div className="lockGroup">
             
             

                <CreatableSelect
                  placeholder={t("Select the variation")}
                  ref={selectRefs.variation} 

                  //menuIsOpen={openSelect === "variation"}
                  
                  isDisabled={testisLoading}
                  isLoading={testisLoading}
                  onChange={handleChangeVariation}
                  onCreateOption={handleCreateVariation}
                  options={filteredVariation}
                  value={newVariation}
                  className="form-control"
                            styles={formSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
                  filterOption={createFilter({ ignoreAccents: false })}
                  tabIndex={6}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && filteredVariation.length > 0) {
                      handleChangeVariation(filteredVariation[0]);
                    }
                  }}
                  // onFocus={() => setOpenSelect("variation")} // ✅ Open when focused
  onBlur={() => setOpenSelect("null")}
   onFocus={markUserNav}
  onMenuOpen={markUserNav}
  onMouseDown={markUserNav}
                />
           
              </div>
  
               <label>{t('Details')}</label>
  
              {/* <div className="flex-h gap" style={{paddingBottom:'0px'}}> */}
                 <div className="attribute-grid">
                <ToggleButton
                  label="Rookie (RC)"
                  name="IsRookie"
                  value={formData?.IsRookie===true ||formData?.IsRookie===1}
                  onChange={() => handleToggleButtonChange("IsRookie")}
                  disabled={variationLocked}
                />
                <ToggleButton
                  label="Patch"
                  name="IsPatch"
                  value={formData?.IsPatch}
                  onChange={() => handleToggleButtonChange("IsPatch")}
                  disabled={variationLocked}
                />

                <ToggleButton
                  label="Jersey"
                  name="IsJersey"
                  value={formData?.IsJersey}
                  onChange={() => handleToggleButtonChange("IsJersey")}
                  disabled={variationLocked}
                />
                <ToggleButton
                  label="Auto"
                  name="IsAuto"
                  value={formData?.IsAuto}
                  onChange={() => handleToggleButtonChange("IsAuto")}
                  disabled={variationLocked}
                />

<div style={{width:'100%',display:'flex',justifyContent:'center',alignContent:'center'}} >             
<label style={{alignContent:'center'}}>{t('IsThisCardNumbered')}?</label>
      <input
  type="text"
  name="Numbered"
  placeholder="e.g. /999"
  value={formData?.Numbered}
  onChange={handleNumberedChange}          
  disabled={variationLocked}
  className="form-control reg"
  style={{ width: "6rem",textAlign:'center'}}
  inputMode="numeric"                       /* mobile numeric keypad */
  pattern="[0-9]*"                          /* HTML validation on submit */
  maxLength={6}                             /* optional: cap length */
  onKeyDown={(e) => {                       /* optional: block non-control keys */
    const allowed = [
      "Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"
    ];
    if (!/[0-9]/.test(e.key) && !allowed.includes(e.key)) e.preventDefault();
  }}
/>
</div> 
              </div>
            </>  ) : (
    <>
      {/* ======= POKÉMON : Set / Card / HoloOverride ======= */}
      {/* <label>{t("Player")}</label> */}
      <div className="form-group">
        {/* Pokémon Set */}
        <label>{t("Set")}</label>
        <Select
          inputValue={pokemonSetInput}
          onInputChange={(val, meta) => {
            if (meta.action === "input-change") setPokemonSetInput(val);
          }}
          onMenuOpen={() => {
            fetchPokemonSets.flush?.();
            if (!pokemonSetInput) fetchPokemonSets("sv");
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.preventDefault();
          }}
          styles={searchSelectStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          menuPlacement="auto"
          placeholder={t("SearchPokemonSet")}
          value={pokemonSet}
          onChange={(opt) => {
            setPokemonSet(opt);
            setPokemonCard(null);
          }}
          options={pokemonSetOptions}
          isClearable
        />

        {/* Pokémon Card (Set must be chosen) */}
        <label className="mt-2">{t("Card")}</label>
        <Select
          
          inputValue={pokemonCardInput}
          onInputChange={(val, meta) => {
            if (meta.action === "input-change") setPokemonCardInput(val);
            if (
              meta.action === "set-value" ||
              meta.action === "menu-close" ||
              meta.action === "input-blur"
            ) {
              setPokemonCardInput("");
            }
          }}
          styles={searchSelectStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          menuPlacement="auto"
          placeholder={
            pokemonSet?.value ? t("SearchPokemonCard") : t("PickSetFirst")
          }
          value={pokemonCard}
          onChange={(opt) => {
            setPokemonCard(opt);
            setPokemonCardInput("");
            setPokemonRarity(opt?.rarity ?? null);
            setFormData((prev) => ({
              ...prev,
              NumberBehind: opt?.number ?? "",
            }));
          }}
          options={pokemonCardOptions}
          isClearable
          getOptionValue={(o) => String(o.value)}
          getOptionLabel={(o) => o.label}
        />

        {/* Optional : Holo override */}
        <div className="mt-2">
          <label>{t("HoloOptional")}</label>
          <CreatableSelect
            value={
              holoOverride ? { value: holoOverride, label: holoOverride } : null
            }
            onChange={(opt) => setHoloOverride(opt?.value || "")}
            onCreateOption={(val) => setHoloOverride(val)}
            placeholder="Ex: Holo, Reverse Holo, Cosmos, Cracked Ice"
            styles={compactSelectStyles}
            isClearable
          />
        </div>
      </div>
    </>
  )}
         
  
         <div className="attribute-grid" style={{justifyContent:'space-around'}}>
            <label htmlFor="SpecialAttribute">
                {t('SpecialPlaceholder')}
               
              </label>

              <label htmlFor="NumberBehind">{t('Number Behind')}#:</label>
 </div>

         <div className="flex-h" style={{justifyContent:'space-between',gap:'4vw'}}>


             
              <input
                type="text"
                name="SpecialAttribute"
                placeholder="SSP/4clr"
                value={formData?.SpecialAttribute}
                onChange={handleInputChange}
                style={{marginLeft:'2vw',textAlign:'center'}}
                className="form-control reg"
                
                tabIndex={7}
                
              />

              

              <div className="lockGroup">
                <input
                  type="text"
                  name="NumberBehind"
                  placeholder="CM-197"
                  value={formData?.NumberBehind}
                  onChange={handleInputChange}
                  className="form-control reg"
                  style={{width:'7rem',textAlign:'center'}}
                  tabIndex={8}
                />

          
              </div>
   
             
            </div>
            </div>
          </div>
   </div>
          {/* Right Section */}
          <div className="mid-section">
          
        <div className="panel">
              <p className="panel-title">Condition</p>
            {/* <div className="form-check"></div> */}
        {/* <label>{t("Graded")}? *</label> */}
            <div className="attribute-grid">
              <ToggleButton
                label="Raw"
                name="Graded"
                value={!formData?.Graded === true||!formData?.Graded === 'Graded'}
                onChange={() => handleToggleButtonChange("Graded")}
                tabindex={formData?.isForSale?15:13}
              />
              <ToggleButton
                label="Graded"
                name="Graded"
                value={!formData?.Graded === false ||!formData?.Graded === 'Raw'}
                onChange={() => handleToggleButtonChange("Graded")}
                tabindex={formData?.isForSale?16:14}
              />

              {/* <ToggleButtonGradedRaw
                label="Graded"
                name="Graded"
                active={formData.Graded === false} // Button is active if formData.Graded is false
                onChange={() => handleToggleButtonChange("Graded")}
              /> */}
              {/* <label htmlFor="Graded">Graded?</label>
                      <select
                        name="Graded"
                        value={formData.Graded}
                        onChange={handleInputChange}
                        className="form-control"
                      >
                        <option value={false}>No</option>
                        <option value={true}>Yes</option>
                      </select> */}
            </div>
            {formData?.Graded === true?(
              <GradingCompanyAndGradeSelection
                formData={formData}
                setFormData={setFormData}
              />
            ):(

            <div className="form-group">
              
              {/* <input
                type="text"
                name="ConditionCard"
                placeholder="Describe the condition"
                value={formData.ConditionCard}
                onChange={handleInputChange}
                className="form-control"
              /> */}
          {!isPokemon?(<ConditionComponent
  formData={formData}
  setFormData={setFormData}
  disableSelect={false}
  forCreateCardForm={false}
  t={t}
  tabindex={7}
  formSelectStyles={formSelectStyles}
  conditionProfile="sports"
/>):(<ConditionComponent
  formData={formData}
  setFormData={setFormData}
  disableSelect={false}
  forCreateCardForm={false}
  t={t}
  tabindex={7}
  formSelectStyles={formSelectStyles}
  conditionProfile="tcg"
/>)}
            </div>)}

</div>

  <div className="panel">
      <div className="panel-header">
  <h3 className="panel-title">{t('Status')}</h3>

</div>
  

            <div className="attribute-grid">
              <ToggleButton
                label="PC"
                name="isPC"
                value={formData?.isPC}
                onChange={() => handleToggleButtonChange("isPC")}
                tabindex={9}
              />
              <ToggleButton
                label="For Sale"
                name="isForSale"
                value={formData?.isForSale}
                onChange={() => handleToggleButtonChange("isForSale")}
                tabindex={10}
              />

              <ToggleButton
                label="For Trade"
                name="isForTrade"
                value={formData?.isForTrade}
                onChange={() => handleToggleButtonChange("isForTrade")}
                tabindex={11}
              />

              <ToggleButton
                label="IsOnEbay"
                name="isOnEbay"
                value={formData?.isOnEbay}
                onChange={() => handleToggleButtonChange("isOnEbay")}
                tabindex={12}
              />
            </div>


            
            {formData?.isForSale === true && (
              <>
              
                {/* <h3>For Sale </h3> */}
                <ForSalePriceAndTemplate
                  initialPrice={formData?.SalePrice}
                  initialShippingTemplate={formData?.ShippingTemplate}
                  onPriceAndShippingChange={handlePriceAndShippingChange}
                  tabIndex={formData?.isForSale?13:null}
                  t={t}
                />
             
              </>
            )}
                   {formData?.isForTrade === true && (
              <>
               
                <ForTradeTradingTemplate
                  userId={userId}
                  setFormData={setFormData}
                  formData={formData}
                  formSelectStyles={formSelectStyles}
                />
  {/* Only show the button if TradingTemplate is valid and not 0 */}
  {formData?.TradingTemplate > 0 && formData?.SeeMore ? (<></>
      // <ToggleButton
      //   label="SeeLess"
      //   name="SeeMore"
      //   value={!formData?.SeeMore}
      //   onChange={() => handleToggleButtonChange("SeeMore")}
      // />
    ) : (
      formData?.TradingTemplate > 0 && (
        <ToggleButton
          label="SeeMore"
          name="SeeMore"
          value={formData?.SeeMore}
          onChange={() => handleToggleButtonChange("SeeMore")}
        />
      )
    )}
  </>
)}
     
    </div>
      <div className="panel">
        <div className="panel-header">
              <p className="panel-title">{t('Value')}
</p> <p
  type="text"
  onClick={() => {
    const ebayUrl = generateEbaySearchUrl(formData, newVariation.label);
    window.open(ebayUrl, "_blank");
  }}
   className="see-comps-button"
  title="Open eBay search with your selected card data"
>
  <img src={loupeIcon} style={{maxWidth:'1.5rem'}}/>{t('See Comps on eBay')}
  </p>
  </div>
            <div className="form-group">
              <label htmlFor="EstimateValue">{t("Estimate Value")}($):</label>
              <div className="flex-h">
              <input
  type="text"
  name="EstimateValue"
  placeholder={t("Estimate Value")}
  value={formData?.EstimateValue}
  onInput={handleNumericInputChange} // Call numeric input handler
  className="form-control reg"
  tabIndex={formData?.isForSale?18:16}
  onFocus={(e) => e.target.select()}
  style={{width:'40%',marginRight:'1vw',padding:'10px'}}
/>

</div>
            </div>

           <div className="form-group">
              <label htmlFor="PaidPrice">{t("Price Paid")}($):</label>
              <div className="input-group">
                <div className="input-group-prepend"></div>
                <input
  type="text"
  name="PaidPrice"
  placeholder={t("Price Paid")}
  value={formData?.PaidPrice}
  onInput={handleNumericInputChange} // Call numeric input handler
  className="form-control reg"
  tabIndex={formData?.isForSale?19:17}
  onFocus={(e) => e.target.select()}
  style={{padding:'10px'}}
/>
            </div>
         </div>
            </div>
      
          </div>

          <div className="image-upload-row">
                    <div className="panel">
              <p className="panel-title">{t('Other')}</p>
            <div className="form-group">
              <label htmlFor="Location">{t("Location")}:</label>
              <div className="lockGroup">
                <input
                  type="text"
                  name="Location"
                  placeholder={`${t("Location")}:(C21)`}
                  value={formData?.Location}
                  onChange={handleInputChange}
                  className="form-control reg"
                  tabIndex={formData?.isForSale?20:18}
                  onFocus={(e) => e.target.select()}
                  
                />

        
              </div>

            </div>
              <div className="form-group">
              {!allowCreateNewCollection ? (
                <>
                  <div className="form-group">
                    <label htmlFor="Collection">
                      {t("Pre-Assign To Collection")}:
                    </label>
                    <div className="lockGroup" style={{width:'22rem',maxWidth:'100%'}}>
                     
<Select
  className="form-control"
                               styles={formSelectStyles}
    menuPortalTarget={document.body}
    menuPosition="fixed"
    menuPlacement="auto"
  tabIndex={formData?.isForSale ? 21 : 19}
  value={
    selectedCollectionLive.Title
  }
  onChange={(selectedOption) => {
    if (!selectedOption) return;
    setSelectedCollectionLive(selectedOption); // ✅ set the full collection object
  }}
  options={collections.map((collection) => ({
    value: collection.ListId,
    label:
      parseInt(collection.ListId) !== 0
        ? `${collection.Title} (${collection.collectionCount})`
        : t("Not Assign"),
   
  }))}
  isSearchable={false}
/>

                      <MySvgButtonPlus onClickDo={handleCreateNewButtonClick} withBox={true} />
                    </div>
                  </div>
                  
                </>
              ) : (
                <>
                  {" "}
                  {createCollectionLabelNewCollection}
                  {collectionNameInputNewCollection}
                  <div className="flex-h">
                    {confirmButtonNewCollection}
                    {cancelButtonNewCollection}
                  </div>
                </>
              )}
           
            {/* {parseInt(selectedCollectionLive)!==0&&<button onClick={()=>handleRenameButtonClick()}>{`Rename`}</button>}
               {allowCollectionRename&&displayRenameCollectionForm()} */}

</div>
          </div>
          <div className="right-section" style={{padding:'0'}}>
  <div className="form-group fitContent" >

<div
  className={`drop-area ${isDragging ? 'dragging' : ''} ${formData?.Image ? 'has-image' : ''}`}
  onDragOver={handleDragOver}
  onDrop={(e) => handleDrop(e, 'Image')}
  onDragEnter={() => setIsDragging(true)}
  onDragLeave={() => setIsDragging(false)}
  onClick={() => { if (!formData?.Image) fileFrontRef.current?.click(); }}
>
  <input
    ref={fileFrontRef}
    type="file"
    id="fileUpload1"
    name="Image"
    accept="image/*"
    onChange={handleImageChange}
    className="hidden-file-input"
  />

  {!formData?.Image && (
    <div className="custom-file-button">
      <img src={SelectorIcon} alt="" />
      <h3>{t("Front")}</h3>
      <p>{t("Drag and drop")}</p>
    </div>
  )}

  {formData?.Image && (
    <>
      <img className="preview" src={previewImage} alt="" />
      <div className="overlay-buttons">
        <button
          className="btn"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); fileFrontRef.current?.click(); }}
        >
          {t("Replace")}
        </button>
        <button
          className="btn"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); removeImage("Image"); }}
        >
          {t("Remove")}
        </button>
      </div>
    </>
  )}
</div>



    {/* Loading Spinner */}
    {isUploading && <div className="loading-spinner">{t('Uploading...')}</div>}


  </div>
</div>

<div className="right-picture">
  <div className="form-group fitContent" style={{textAlign: 'center',}}>
    
    
    {/* Drag and Drop area for Back Image */}
<div
  className={`drop-area ${isDragging ? 'dragging' : ''} ${formData?.ImageBack ? 'has-image' : ''}`}
  onDragOver={handleDragOver}
  onDrop={(e) => handleDrop(e, 'ImageBack')}
  onDragEnter={() => setIsDragging(true)}
  onDragLeave={() => setIsDragging(false)}
  onClick={() => { if (!formData?.ImageBack) fileBackRef.current?.click(); }}
>
  <input
    ref={fileBackRef}
    type="file"
    id="fileUpload2"
    name="ImageBack"
    accept="image/*"
    onChange={handleImageChange}
    className="hidden-file-input"
  />

  {!formData?.ImageBack && (
    <div className="custom-file-button">
      <img src={SelectorIcon} alt="" />
      <h3>{t("Back")}</h3>
      <p>{t("Drag and drop")}</p>
    </div>
  )}

  {formData?.ImageBack && (
    <>
      <img className="preview" src={previewImageBack} alt="" />
      <div className="overlay-buttons">
        <button
          className="btn"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); fileBackRef.current?.click(); }}
        >
          {t("Replace")}
        </button>
        <button
          className="btn"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); removeImage("ImageBack"); }}
        >
          {t("Remove")}
        </button>
      </div>
    </>
  )}
</div>

    
    {/* Loading Spinner */}
    {isUploading && <div className="loading-spinner">{t('Uploading...')}
</div>}

{/* <div className="loading-spinner">Uploading...</div> */}
 

  </div>
               
</div>


{/* Actions row */}
<div className="form-actions">
  <button
    type="button"
    className="btn-discard"
    onClick={()=>initializeData()} // <- make this reset / close
  >
    {t("Discard")}
  </button>

  <button
    type="button"
    className="btn-submit"
    onClick={handleSubmit}
    disabled={isLoading}
    tabIndex={formData?.isForSale ? 22 : 20}
  >
    {isLoading && <span className="spinner" aria-hidden="true" />}
    {isLoading ? t("Updating Card...") : t("Update")}
  </button>
</div>




</div>


       
          {errorMessage && <p>Error: {errorMessage}</p>}
          {successMessage && <p>{successMessage}</p>}
        </form>
      
    </>
  );
}


export default CardEditV2;
